[
  {
    "name": "Afghanistan",
    "code": "AF",
    "dial_code": "+93",
    "flag": "🇦🇫",
    "states": [
      "Badakhshan",
      "Badghis",
      "Baghlan",
      "Balkh",
      "Bamyan",
      "Daykundi",
      "Farah",
      "Faryab",
      "Ghazni",
      "Ghōr",
      "Helmand",
      "Herat",
      "Jowzjan",
      "Kabul",
      "Kandahar",
      "Kapisa",
      "Khost",
      "Kunar",
      "Kunduz Province",
      "Laghman",
      "Logar",
      "Nangarhar",
      "Nimruz",
      "Nuristan",
      "Paktia",
      "Paktika",
      "Panjshir",
      "Parwan",
      "Samangan",
      "Sar-e Pol",
      "Takhar",
      "Urozgan",
      "Zabul"
    ]
  },
  {
    "name": "Aland Islands",
    "code": "AX",
    "dial_code": "+358",
    "flag": "🇦🇽",
    "states": [
      "Brändö",
      "Eckerö",
      "Finström",
      "Föglö",
      "Geta",
      "Hammarland",
      "Jomala",
      "Kökar",
      "Kumlinge",
      "Lemland",
      "Lumparland",
      "Mariehamn",
      "Saltvik",
      "Sottunga",
      "Sund",
      "Vårdö"
    ]
  },
  {
    "name": "Albania",
    "code": "AL",
    "dial_code": "+355",
    "flag": "🇦🇱",
    "states": [
      "Berat",
      "Berat",
      "Bulqizë",
      "Delvinë",
      "Devoll",
      "Dibër",
      "Dibër",
      "Durrës",
      "Durrës",
      "Elbasan",
      "Fier",
      "Fier",
      "Gjirokastër",
      "Gjirokastër",
      "Gramsh",
      "Has",
      "Kavajë",
      "Kolonjë",
      "Korçë",
      "Korçë",
      "Krujë",
      "Kuçovë",
      "Kukës",
      "Kukës",
      "Kurbin",
      "Lezhë",
      "Lezhë",
      "Librazhd",
      "Lushnjë",
      "Malësi e Madhe",
      "Mallakastër",
      "Mat",
      "Mirditë",
      "Peqin",
      "Përmet",
      "Pogradec",
      "Pukë",
      "Sarandë",
      "Shkodër",
      "Shkodër",
      "Skrapar",
      "Tepelenë",
      "Tirana",
      "Tirana",
      "Tropojë",
      "Vlorë",
      "Vlorë"
    ]
  },
  {
    "name": "Algeria",
    "code": "DZ",
    "dial_code": "+213",
    "flag": "🇩🇿",
    "states": [
      "Adrar",
      "Aïn Defla",
      "Aïn Témouchent",
      "Algiers",
      "Annaba",
      "Batna",
      "Béchar",
      "Béjaïa",
      "Béni Abbès",
      "Biskra",
      "Blida",
      "Bordj Baji Mokhtar",
      "Bordj Bou Arréridj",
      "Bouïra",
      "Boumerdès",
      "Chlef",
      "Constantine",
      "Djanet",
      "Djelfa",
      "El Bayadh",
      "El M'ghair",
      "El Menia",
      "El Oued",
      "El Tarf",
      "Ghardaïa",
      "Guelma",
      "Illizi",
      "In Guezzam",
      "In Salah",
      "Jijel",
      "Khenchela",
      "Laghouat",
      "M'Sila",
      "Mascara",
      "Médéa",
      "Mila",
      "Mostaganem",
      "Naama",
      "Oran",
      "Ouargla",
      "Ouled Djellal",
      "Oum El Bouaghi",
      "Relizane",
      "Saïda",
      "Sétif",
      "Sidi Bel Abbès",
      "Skikda",
      "Souk Ahras",
      "Tamanghasset",
      "Tébessa",
      "Tiaret",
      "Timimoun",
      "Tindouf",
      "Tipasa",
      "Tissemsilt",
      "Tizi Ouzou",
      "Tlemcen",
      "Touggourt"
    ]
  },
  {
    "name": "American Samoa",
    "code": "AS",
    "dial_code": "+1",
    "flag": "🇦🇸",
    "states": [
      "Eastern",
      "Manuʻa",
      "Rose",
      "Swains",
      "Western"
    ]
  },
  {
    "name": "Andorra",
    "code": "AD",
    "dial_code": "+376",
    "flag": "🇦🇩",
    "states": [
      "Andorra la Vella",
      "Canillo",
      "Encamp",
      "Escaldes-Engordany",
      "La Massana",
      "Ordino",
      "Sant Julià de Lòria"
    ]
  },
  {
    "name": "Angola",
    "code": "AO",
    "dial_code": "+244",
    "flag": "🇦🇴",
    "states": [
      "Bengo",
      "Benguela",
      "Bié",
      "Cabinda",
      "Cuando Cubango",
      "Cuanza",
      "Cuanza Norte",
      "Cunene",
      "Huambo",
      "Huíla",
      "Luanda",
      "Lunda Norte",
      "Lunda Sul",
      "Malanje",
      "Moxico",
      "Uíge",
      "Zaire"
    ]
  },
  {
    "name": "Anguilla",
    "code": "AI",
    "dial_code": "+1",
    "flag": "🇦🇮",
    "states": [
      "Blowing Point",
      "East End",
      "George Hill",
      "Island Harbour",
      "North Hill",
      "North Side",
      "Sandy Ground",
      "Sandy Hill",
      "South Hill",
      "Stoney Ground",
      "The Farrington",
      "The Quarter",
      "The Valley",
      "West End"
    ]
  },
  {
    "name": "Antarctica",
    "code": "AQ",
    "dial_code": "+672",
    "flag": "🇦🇶",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Antigua and Barbuda",
    "code": "AG",
    "dial_code": "+1",
    "flag": "🇦🇬",
    "states": [
      "Barbuda",
      "Redonda",
      "Saint George",
      "Saint John",
      "Saint Mary",
      "Saint Paul",
      "Saint Peter",
      "Saint Philip"
    ]
  },
  {
    "name": "Argentina",
    "code": "AR",
    "dial_code": "+54",
    "flag": "🇦🇷",
    "states": [
      "Autonomous City of Buenos Aires",
      "Buenos Aires",
      "Catamarca",
      "Chaco",
      "Chubut",
      "Córdoba",
      "Corrientes",
      "Entre Ríos",
      "Formosa",
      "Jujuy",
      "La Pampa",
      "La Rioja",
      "Mendoza",
      "Misiones",
      "Neuquén",
      "Río Negro",
      "Salta",
      "San Juan",
      "San Luis",
      "Santa Cruz",
      "Santa Fe",
      "Santiago del Estero",
      "Tierra del Fuego",
      "Tucumán"
    ]
  },
  {
    "name": "Armenia",
    "code": "AM",
    "dial_code": "+374",
    "flag": "🇦🇲",
    "states": [
      "Aragatsotn",
      "Ararat",
      "Armavir",
      "Gegharkunik",
      "Kotayk",
      "Lori",
      "Shirak",
      "Syunik",
      "Tavush",
      "Vayots Dzor",
      "Yerevan"
    ]
  },
  {
    "name": "Aruba",
    "code": "AW",
    "dial_code": "+297",
    "flag": "🇦🇼",
    "states": [
      "Noord",
      "Oranjestad",
      "Oranjestad East",
      "Oranjestad West",
      "Paradera",
      "San Nicolaas Noord",
      "San Nicolaas Zuid",
      "Santa Cruz",
      "Savaneta"
    ]
  },
  {
    "name": "Australia",
    "code": "AU",
    "dial_code": "+61",
    "flag": "🇦🇺",
    "states": [
      "Australian Capital Territory",
      "New South Wales",
      "Northern Territory",
      "Queensland",
      "South Australia",
      "Tasmania",
      "Victoria",
      "Western Australia"
    ]
  },
  {
    "name": "Austria",
    "code": "AT",
    "dial_code": "+43",
    "flag": "🇦🇹",
    "states": [
      "Burgenland",
      "Carinthia",
      "Lower Austria",
      "Salzburg",
      "Styria",
      "Tyrol",
      "Upper Austria",
      "Vienna",
      "Vorarlberg"
    ]
  },
  {
    "name": "Azerbaijan",
    "code": "AZ",
    "dial_code": "+994",
    "flag": "🇦🇿",
    "states": [
      "Absheron",
      "Agdam",
      "Agdash",
      "Aghjabadi",
      "Agstafa",
      "Agsu",
      "Astara",
      "Babek",
      "Baku",
      "Balakan",
      "Barda",
      "Beylagan",
      "Bilasuvar",
      "Dashkasan",
      "Fizuli",
      "Ganja",
      "Gədəbəy",
      "Gobustan",
      "Goranboy",
      "Goychay",
      "Goygol",
      "Hajigabul",
      "Imishli",
      "Ismailli",
      "Jabrayil",
      "Jalilabad",
      "Julfa",
      "Kalbajar",
      "Kangarli",
      "Khachmaz",
      "Khizi",
      "Khojali",
      "Kurdamir",
      "Lachin",
      "Lankaran",
      "Lankaran",
      "Lerik",
      "Martuni",
      "Masally",
      "Mingachevir",
      "Nakhchivan",
      "Neftchala",
      "Oghuz",
      "Ordubad",
      "Qabala",
      "Qakh",
      "Qazakh",
      "Quba",
      "Qubadli",
      "Qusar",
      "Saatly",
      "Sabirabad",
      "Sadarak",
      "Salyan",
      "Samukh",
      "Shabran",
      "Shahbuz",
      "Shaki",
      "Shaki",
      "Shamakhi",
      "Shamkir",
      "Sharur",
      "Shirvan",
      "Shusha",
      "Siazan",
      "Sumqayit",
      "Tartar",
      "Tovuz",
      "Ujar",
      "Yardymli",
      "Yevlakh",
      "Yevlakh",
      "Zangilan",
      "Zaqatala",
      "Zardab"
    ]
  },
  {
    "name": "Bahrain",
    "code": "BH",
    "dial_code": "+973",
    "flag": "🇧🇭",
    "states": [
      "Capital",
      "Central",
      "Muharraq",
      "Northern",
      "Southern"
    ]
  },
  {
    "name": "Bangladesh",
    "code": "BD",
    "dial_code": "+880",
    "flag": "🇧🇩",
    "states": [
      "Barisal ",
      "Chittagong ",
      "Dhaka ",
      "Khulna ",
      "Mymensingh ",
      "Rajshahi ",
      "Rangpur ",
      "Sylhet "
    ]
  },
  {
    "name": "Barbados",
    "code": "BB",
    "dial_code": "+1",
    "flag": "🇧🇧",
    "states": [
      "Christ Church",
      "Saint Andrew",
      "Saint George",
      "Saint James",
      "Saint John",
      "Saint Joseph",
      "Saint Lucy",
      "Saint Michael",
      "Saint Peter",
      "Saint Philip",
      "Saint Thomas"
    ]
  },
  {
    "name": "Belarus",
    "code": "BY",
    "dial_code": "+375",
    "flag": "🇧🇾",
    "states": [
      "Brest",
      "Gomel",
      "Grodno",
      "Minsk",
      "Minsk",
      "Mogilev",
      "Vitebsk"
    ]
  },
  {
    "name": "Belgium",
    "code": "BE",
    "dial_code": "+32",
    "flag": "🇧🇪",
    "states": [
      "Antwerp",
      "Brussels-Capital ",
      "East Flanders",
      "Flanders",
      "Flemish Brabant",
      "Hainaut",
      "Liège",
      "Limburg",
      "Luxembourg",
      "Namur",
      "Wallonia",
      "Walloon Brabant",
      "West Flanders"
    ]
  },
  {
    "name": "Belize",
    "code": "BZ",
    "dial_code": "+501",
    "flag": "🇧🇿",
    "states": [
      "Belize",
      "Cayo",
      "Corozal",
      "Orange Walk",
      "Stann Creek",
      "Toledo"
    ]
  },
  {
    "name": "Benin",
    "code": "BJ",
    "dial_code": "+229",
    "flag": "🇧🇯",
    "states": [
      "Alibori",
      "Atakora",
      "Atlantique",
      "Borgou",
      "Collines",
      "Donga",
      "Kouffo",
      "Littoral",
      "Mono",
      "Ouémé",
      "Plateau",
      "Zou"
    ]
  },
  {
    "name": "Bermuda",
    "code": "BM",
    "dial_code": "+1",
    "flag": "🇧🇲",
    "states": [
      "Devonshire",
      "Hamilton",
      "Paget",
      "Pembroke",
      "Saint George's",
      "Sandys",
      "Smith's",
      "Southampton",
      "Warwick"
    ]
  },
  {
    "name": "Bhutan",
    "code": "BT",
    "dial_code": "+975",
    "flag": "🇧🇹",
    "states": [
      "Bumthang ",
      "Chukha ",
      "Dagana ",
      "Gasa ",
      "Haa ",
      "Lhuntse ",
      "Mongar ",
      "Paro ",
      "Pemagatshel ",
      "Punakha ",
      "Samdrup Jongkhar ",
      "Samtse ",
      "Sarpang ",
      "Thimphu ",
      "Trashi Yangtse\t",
      "Trashigang ",
      "Trongsa ",
      "Tsirang ",
      "Wangdue Phodrang ",
      "Zhemgang "
    ]
  },
  {
    "name": "Bolivia",
    "code": "BO",
    "dial_code": "+591",
    "flag": "🇧🇴",
    "states": [
      "Beni",
      "Chuquisaca",
      "Cochabamba",
      "La Paz",
      "Oruro",
      "Pando",
      "Potosí",
      "Santa Cruz",
      "Tarija"
    ]
  },
  {
    "name": "Bonaire, Sint Eustatius and Saba",
    "code": "BQ",
    "dial_code": "+599",
    "flag": "🇧🇶",
    "states": [
      "Bonaire",
      "Saba",
      "Sint Eustatius"
    ]
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "BA",
    "dial_code": "+387",
    "flag": "🇧🇦",
    "states": [
      "Bosnian Podrinje",
      "Brčko",
      "Canton 10",
      "Central Bosnia",
      "Federation of Bosnia and Herzegovina",
      "Herzegovina-Neretva",
      "Posavina",
      "Republika Srpska",
      "Sarajevo",
      "Tuzla",
      "Una-Sana",
      "West Herzegovina",
      "Zenica-Doboj"
    ]
  },
  {
    "name": "Botswana",
    "code": "BW",
    "dial_code": "+267",
    "flag": "🇧🇼",
    "states": [
      "Central",
      "Ghanzi",
      "Kgalagadi",
      "Kgatleng",
      "Kweneng",
      "Ngamiland",
      "North-East",
      "North-West",
      "South-East",
      "Southern"
    ]
  },
  {
    "name": "Bouvet Island",
    "code": "BV",
    "dial_code": "+0055",
    "flag": "🇧🇻",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Brazil",
    "code": "BR",
    "dial_code": "+55",
    "flag": "🇧🇷",
    "states": [
      "Acre",
      "Alagoas",
      "Amapá",
      "Amazonas",
      "Bahia",
      "Ceará",
      "Distrito Federal",
      "Espírito Santo",
      "Goiás",
      "Maranhão",
      "Mato Grosso",
      "Mato Grosso do Sul",
      "Minas Gerais",
      "Pará",
      "Paraíba",
      "Paraná",
      "Pernambuco",
      "Piauí",
      "Rio de Janeiro",
      "Rio Grande do Norte",
      "Rio Grande do Sul",
      "Rondônia",
      "Roraima",
      "Santa Catarina",
      "São Paulo",
      "Sergipe",
      "Tocantins"
    ]
  },
  {
    "name": "British Indian Ocean Territory",
    "code": "IO",
    "dial_code": "+246",
    "flag": "🇮🇴",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Brunei",
    "code": "BN",
    "dial_code": "+673",
    "flag": "🇧🇳",
    "states": [
      "Belait",
      "Brunei-Muara",
      "Temburong",
      "Tutong"
    ]
  },
  {
    "name": "Bulgaria",
    "code": "BG",
    "dial_code": "+359",
    "flag": "🇧🇬",
    "states": [
      "Blagoevgrad",
      "Burgas",
      "Dobrich",
      "Gabrovo",
      "Haskovo",
      "Kardzhali",
      "Kyustendil",
      "Lovech",
      "Montana",
      "Pazardzhik",
      "Pernik",
      "Pleven",
      "Plovdiv",
      "Razgrad",
      "Ruse",
      "Shumen",
      "Silistra",
      "Sliven",
      "Smolyan",
      "Sofia",
      "Sofia City",
      "Stara Zagora",
      "Targovishte",
      "Varna",
      "Veliko Tarnovo",
      "Vidin",
      "Vratsa",
      "Yambol"
    ]
  },
  {
    "name": "Burkina Faso",
    "code": "BF",
    "dial_code": "+226",
    "flag": "🇧🇫",
    "states": [
      "Balé",
      "Bam",
      "Banwa",
      "Bazèga",
      "Boucle du Mouhoun",
      "Bougouriba",
      "Boulgou",
      "Boulkiemde",
      "Cascades",
      "Centre",
      "Centre-Est",
      "Centre-Nord",
      "Centre-Ouest",
      "Centre-Sud",
      "Comoé",
      "Est",
      "Ganzourgou",
      "Gnagna",
      "Gourma",
      "Hauts-Bassins",
      "Houet",
      "Ioba",
      "Kadiogo",
      "Kénédougou",
      "Komondjari",
      "Kompienga",
      "Kossi",
      "Koulpélogo",
      "Kouritenga",
      "Kourwéogo",
      "Léraba",
      "Loroum",
      "Mouhoun",
      "Nahouri",
      "Namentenga",
      "Nayala",
      "Nord",
      "Noumbiel",
      "Oubritenga",
      "Oudalan",
      "Passoré",
      "Plateau-Central",
      "Poni",
      "Sahel",
      "Sanguié",
      "Sanmatenga",
      "Séno",
      "Sissili",
      "Soum",
      "Sourou",
      "Sud-Ouest",
      "Tapoa",
      "Tuy",
      "Yagha",
      "Yatenga",
      "Ziro",
      "Zondoma",
      "Zoundwéogo"
    ]
  },
  {
    "name": "Burundi",
    "code": "BI",
    "dial_code": "+257",
    "flag": "🇧🇮",
    "states": [
      "Bubanza",
      "Bujumbura Mairie",
      "Bujumbura Rural",
      "Bururi",
      "Cankuzo",
      "Cibitoke",
      "Gitega",
      "Karuzi",
      "Kayanza",
      "Kirundo",
      "Makamba",
      "Muramvya",
      "Muyinga",
      "Mwaro",
      "Ngozi",
      "Rumonge",
      "Rutana",
      "Ruyigi"
    ]
  },
  {
    "name": "Cambodia",
    "code": "KH",
    "dial_code": "+855",
    "flag": "🇰🇭",
    "states": [
      "Banteay Meanchey",
      "Battambang",
      "Kampong Cham",
      "Kampong Chhnang",
      "Kampong Speu",
      "Kampong Thom",
      "Kampot",
      "Kandal",
      "Kep",
      "Koh Kong",
      "Kratie",
      "Mondulkiri",
      "Oddar Meanchey",
      "Pailin",
      "Phnom Penh",
      "Preah Vihear",
      "Prey Veng",
      "Pursat",
      "Ratanakiri",
      "Siem Reap",
      "Sihanoukville",
      "Stung Treng",
      "Svay Rieng",
      "Takeo"
    ]
  },
  {
    "name": "Cameroon",
    "code": "CM",
    "dial_code": "+237",
    "flag": "🇨🇲",
    "states": [
      "Adamawa",
      "Centre",
      "East",
      "Far North",
      "Littoral",
      "North",
      "Northwest",
      "South",
      "Southwest",
      "West"
    ]
  },
  {
    "name": "Canada",
    "code": "CA",
    "dial_code": "+1",
    "flag": "🇨🇦",
    "states": [
      "Alberta",
      "British Columbia",
      "Manitoba",
      "New Brunswick",
      "Newfoundland and Labrador",
      "Northwest Territories",
      "Nova Scotia",
      "Nunavut",
      "Ontario",
      "Prince Edward Island",
      "Quebec",
      "Saskatchewan",
      "Yukon"
    ]
  },
  {
    "name": "Cape Verde",
    "code": "CV",
    "dial_code": "+238",
    "flag": "🇨🇻",
    "states": [
      "Barlavento Islands",
      "Boa Vista",
      "Brava",
      "Maio",
      "Mosteiros",
      "Paul",
      "Porto Novo",
      "Praia",
      "Ribeira Brava",
      "Ribeira Grande",
      "Ribeira Grande de Santiago",
      "Sal",
      "Santa Catarina",
      "Santa Catarina do Fogo",
      "Santa Cruz",
      "São Domingos",
      "São Filipe",
      "São Lourenço dos Órgãos",
      "São Miguel",
      "São Vicente",
      "Sotavento Islands",
      "Tarrafal",
      "Tarrafal de São Nicolau"
    ]
  },
  {
    "name": "Cayman Islands",
    "code": "KY",
    "dial_code": "+1",
    "flag": "🇰🇾",
    "states": [
      "Cayman Brac",
      "Grand Cayman",
      "Little Cayman"
    ]
  },
  {
    "name": "Central African Republic",
    "code": "CF",
    "dial_code": "+236",
    "flag": "🇨🇫",
    "states": [
      "Bamingui-Bangoran",
      "Bangui",
      "Basse-Kotto",
      "Haut-Mbomou",
      "Haute-Kotto",
      "Kémo",
      "Lobaye",
      "Mambéré-Kadéï",
      "Mbomou",
      "Nana-Grébizi",
      "Nana-Mambéré",
      "Ombella-M'Poko",
      "Ouaka",
      "Ouham",
      "Ouham-Pendé",
      "Sangha-Mbaéré",
      "Vakaga"
    ]
  },
  {
    "name": "Chad",
    "code": "TD",
    "dial_code": "+235",
    "flag": "🇹🇩",
    "states": [
      "Bahr el Gazel",
      "Batha",
      "Borkou",
      "Chari-Baguirmi",
      "Ennedi-Est",
      "Ennedi-Ouest",
      "Guéra",
      "Hadjer-Lamis",
      "Kanem",
      "Lac",
      "Logone Occidental",
      "Logone Oriental",
      "Mandoul",
      "Mayo-Kebbi Est",
      "Mayo-Kebbi Ouest",
      "Moyen-Chari",
      "N'Djamena",
      "Ouaddaï",
      "Salamat",
      "Sila",
      "Tandjilé",
      "Tibesti",
      "Wadi Fira"
    ]
  },
  {
    "name": "Chile",
    "code": "CL",
    "dial_code": "+56",
    "flag": "🇨🇱",
    "states": [
      "Aisén del General Carlos Ibañez del Campo",
      "Antofagasta",
      "Arica y Parinacota",
      "Atacama",
      "Biobío",
      "Coquimbo",
      "La Araucanía",
      "Libertador General Bernardo O'Higgins",
      "Los Lagos",
      "Los Ríos",
      "Magallanes y de la Antártica Chilena",
      "Maule",
      "Ñuble",
      "Región Metropolitana de Santiago",
      "Tarapacá",
      "Valparaíso"
    ]
  },
  {
    "name": "China",
    "code": "CN",
    "dial_code": "+86",
    "flag": "🇨🇳",
    "states": [
      "Anhui",
      "Beijing",
      "Chongqing",
      "Fujian",
      "Gansu",
      "Guangdong",
      "Guangxi Zhuang",
      "Guizhou",
      "Hainan",
      "Hebei",
      "Heilongjiang",
      "Henan",
      "Hong Kong SAR",
      "Hubei",
      "Hunan",
      "Inner Mongolia",
      "Jiangsu",
      "Jiangxi",
      "Jilin",
      "Liaoning",
      "Macau SAR",
      "Ningxia Huizu",
      "Qinghai",
      "Shaanxi",
      "Shandong",
      "Shanghai",
      "Shanxi",
      "Sichuan",
      "Taiwan",
      "Tianjin",
      "Xinjiang",
      "Xizang",
      "Yunnan",
      "Zhejiang"
    ]
  },
  {
    "name": "Christmas Island",
    "code": "CX",
    "dial_code": "+61",
    "flag": "🇨🇽",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Cocos (Keeling) Islands",
    "code": "CC",
    "dial_code": "+61",
    "flag": "🇨🇨",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Colombia",
    "code": "CO",
    "dial_code": "+57",
    "flag": "🇨🇴",
    "states": [
      "Amazonas",
      "Antioquia",
      "Arauca",
      "Atlántico",
      "Bogotá D.C.",
      "Bolívar",
      "Boyacá",
      "Caldas",
      "Caquetá",
      "Casanare",
      "Cauca",
      "Cesar",
      "Chocó",
      "Córdoba",
      "Cundinamarca",
      "Guainía",
      "Guaviare",
      "Huila",
      "La Guajira",
      "Magdalena",
      "Meta",
      "Nariño",
      "Norte de Santander",
      "Putumayo",
      "Quindío",
      "Risaralda",
      "San Andrés, Providencia y Santa Catalina",
      "Santander",
      "Sucre",
      "Tolima",
      "Valle del Cauca",
      "Vaupés",
      "Vichada"
    ]
  },
  {
    "name": "Comoros",
    "code": "KM",
    "dial_code": "+269",
    "flag": "🇰🇲",
    "states": [
      "Anjouan",
      "Grande Comore",
      "Mohéli"
    ]
  },
  {
    "name": "Congo",
    "code": "CG",
    "dial_code": "+242",
    "flag": "🇨🇬",
    "states": [
      "Bouenza",
      "Brazzaville",
      "Cuvette",
      "Cuvette-Ouest",
      "Kouilou",
      "Lékoumou",
      "Likouala",
      "Niari",
      "Plateaux",
      "Pointe-Noire",
      "Pool",
      "Sangha"
    ]
  },
  {
    "name": "Cook Islands",
    "code": "CK",
    "dial_code": "+682",
    "flag": "🇨🇰",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Costa Rica",
    "code": "CR",
    "dial_code": "+506",
    "flag": "🇨🇷",
    "states": [
      "Alajuela",
      "Cartago",
      "Guanacaste",
      "Heredia",
      "Limón",
      "Puntarenas",
      "San José"
    ]
  },
  {
    "name": "Cote D'Ivoire (Ivory Coast)",
    "code": "CI",
    "dial_code": "+225",
    "flag": "🇨🇮",
    "states": [
      "Abidjan",
      "Agnéby",
      "Bafing",
      "Bas-Sassandra",
      "Comoé",
      "Denguélé",
      "Dix-Huit Montagnes",
      "Fromager",
      "Gôh-Djiboua",
      "Haut-Sassandra",
      "Lacs",
      "Lagunes",
      "Marahoué",
      "Montagnes",
      "Moyen-Cavally",
      "Moyen-Comoé",
      "N'zi-Comoé",
      "Sassandra-Marahoué",
      "Savanes",
      "Sud-Bandama",
      "Sud-Comoé",
      "Vallée du Bandama",
      "Woroba",
      "Worodougou",
      "Yamoussoukro",
      "Zanzan"
    ]
  },
  {
    "name": "Croatia",
    "code": "HR",
    "dial_code": "+385",
    "flag": "🇭🇷",
    "states": [
      "Bjelovar-Bilogora",
      "Brod-Posavina",
      "Dubrovnik-Neretva",
      "Istria",
      "Karlovac",
      "Koprivnica-Križevci",
      "Krapina-Zagorje",
      "Lika-Senj",
      "Međimurje",
      "Osijek-Baranja",
      "Požega-Slavonia",
      "Primorje-Gorski Kotar",
      "Šibenik-Knin",
      "Sisak-Moslavina",
      "Split-Dalmatia",
      "Varaždin",
      "Virovitica-Podravina",
      "Vukovar-Syrmia",
      "Zadar",
      "Zagreb",
      "Zagreb"
    ]
  },
  {
    "name": "Cuba",
    "code": "CU",
    "dial_code": "+53",
    "flag": "🇨🇺",
    "states": [
      "Artemisa",
      "Camagüey",
      "Ciego de Ávila",
      "Cienfuegos",
      "Granma",
      "Guantánamo",
      "Havana",
      "Holguín",
      "Isla de la Juventud",
      "Las Tunas",
      "Matanzas",
      "Mayabeque",
      "Pinar del Río",
      "Sancti Spíritus",
      "Santiago de Cuba",
      "Villa Clara"
    ]
  },
  {
    "name": "Curaçao",
    "code": "CW",
    "dial_code": "+599",
    "flag": "🇨🇼",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Cyprus",
    "code": "CY",
    "dial_code": "+357",
    "flag": "🇨🇾",
    "states": [
      "Famagusta (Mağusa)",
      "Kyrenia (Keryneia)",
      "Larnaca (Larnaka)",
      "Limassol (Leymasun)",
      "Nicosia (Lefkoşa)",
      "Paphos (Pafos)"
    ]
  },
  {
    "name": "Czech Republic",
    "code": "CZ",
    "dial_code": "+420",
    "flag": "🇨🇿",
    "states": [
      "Benešov",
      "Beroun",
      "Blansko",
      "Břeclav",
      "Brno-město",
      "Brno-venkov",
      "Bruntál",
      "Česká Lípa",
      "České Budějovice",
      "Český Krumlov",
      "Cheb",
      "Chomutov",
      "Chrudim",
      "Děčín",
      "Domažlice",
      "Frýdek-Místek",
      "Havlíčkův Brod",
      "Hodonín",
      "Hradec Králové",
      "Jablonec nad Nisou",
      "Jeseník",
      "Jičín",
      "Jihlava",
      "Jihočeský kraj",
      "Jihomoravský kraj",
      "Jindřichův Hradec",
      "Karlovarský kraj",
      "Karlovy Vary",
      "Karviná",
      "Kladno",
      "Klatovy",
      "Kolín",
      "Kraj Vysočina",
      "Královéhradecký kraj",
      "Kroměříž",
      "Kutná Hora",
      "Liberec",
      "Liberecký kraj",
      "Litoměřice",
      "Louny",
      "Mělník",
      "Mladá Boleslav",
      "Moravskoslezský kraj",
      "Most",
      "Náchod",
      "Nový Jičín",
      "Nymburk",
      "Olomouc",
      "Olomoucký kraj",
      "Opava",
      "Ostrava-město",
      "Pardubice",
      "Pardubický kraj",
      "Pelhřimov",
      "Písek",
      "Plzeň-jih",
      "Plzeň-město",
      "Plzeň-sever",
      "Plzeňský kraj",
      "Prachatice",
      "Praha-východ",
      "Praha-západ",
      "Praha, Hlavní město",
      "Přerov",
      "Příbram",
      "Prostějov",
      "Rakovník",
      "Rokycany",
      "Rychnov nad Kněžnou",
      "Semily",
      "Sokolov",
      "Strakonice",
      "Středočeský kraj",
      "Šumperk",
      "Svitavy",
      "Tábor",
      "Tachov",
      "Teplice",
      "Třebíč",
      "Trutnov",
      "Uherské Hradiště",
      "Ústecký kraj",
      "Ústí nad Labem",
      "Ústí nad Orlicí",
      "Vsetín",
      "Vyškov",
      "Žďár nad Sázavou",
      "Zlín",
      "Zlínský kraj",
      "Znojmo"
    ]
  },
  {
    "name": "Democratic Republic of the Congo",
    "code": "CD",
    "dial_code": "+243",
    "flag": "🇨🇩",
    "states": [
      "Bas-Uélé",
      "Équateur",
      "Haut-Katanga",
      "Haut-Lomami",
      "Haut-Uélé",
      "Ituri",
      "Kasaï",
      "Kasaï Central",
      "Kasaï Oriental",
      "Kinshasa",
      "Kongo Central",
      "Kwango",
      "Kwilu",
      "Lomami",
      "Lualaba",
      "Mai-Ndombe",
      "Maniema",
      "Mongala",
      "Nord-Kivu",
      "Nord-Ubangi",
      "Sankuru",
      "Sud-Kivu",
      "Sud-Ubangi",
      "Tanganyika",
      "Tshopo",
      "Tshuapa"
    ]
  },
  {
    "name": "Denmark",
    "code": "DK",
    "dial_code": "+45",
    "flag": "🇩🇰",
    "states": [
      "Central Denmark",
      "Denmark",
      "North Denmark",
      "Southern Denmark",
      "Zealand"
    ]
  },
  {
    "name": "Djibouti",
    "code": "DJ",
    "dial_code": "+253",
    "flag": "🇩🇯",
    "states": [
      "Ali Sabieh",
      "Arta",
      "Dikhil",
      "Djibouti",
      "Obock",
      "Tadjourah"
    ]
  },
  {
    "name": "Dominica",
    "code": "DM",
    "dial_code": "+1",
    "flag": "🇩🇲",
    "states": [
      "Saint Andrew",
      "Saint David",
      "Saint George",
      "Saint John",
      "Saint Joseph",
      "Saint Luke",
      "Saint Mark",
      "Saint Patrick",
      "Saint Paul",
      "Saint Peter"
    ]
  },
  {
    "name": "Dominican Republic",
    "code": "DO",
    "dial_code": "+1",
    "flag": "🇩🇴",
    "states": [
      "Azua",
      "Baoruco",
      "Barahona",
      "Dajabón",
      "Distrito Nacional",
      "Duarte",
      "El Seibo",
      "Espaillat",
      "Hato Mayor",
      "Hermanas Mirabal",
      "Independencia",
      "La Altagracia",
      "La Romana",
      "La Vega",
      "María Trinidad Sánchez",
      "Monseñor Nouel",
      "Monte Cristi",
      "Monte Plata",
      "Pedernales",
      "Peravia",
      "Puerto Plata",
      "Samaná",
      "San Cristóbal",
      "San José de Ocoa",
      "San Juan",
      "San Pedro de Macorís",
      "Sánchez Ramírez",
      "Santiago",
      "Santiago Rodríguez",
      "Santo Domingo",
      "Valverde"
    ]
  },
  {
    "name": "Ecuador",
    "code": "EC",
    "dial_code": "+593",
    "flag": "🇪🇨",
    "states": [
      "Azuay",
      "Bolívar",
      "Cañar",
      "Carchi",
      "Chimborazo",
      "Cotopaxi",
      "El Oro",
      "Esmeraldas",
      "Galápagos",
      "Guayas",
      "Imbabura",
      "Loja",
      "Los Ríos",
      "Manabí",
      "Morona-Santiago",
      "Napo",
      "Orellana",
      "Pastaza",
      "Pichincha",
      "Santa Elena",
      "Santo Domingo de los Tsáchilas",
      "Sucumbíos",
      "Tungurahua",
      "Zamora Chinchipe"
    ]
  },
  {
    "name": "Egypt",
    "code": "EG",
    "dial_code": "+20",
    "flag": "🇪🇬",
    "states": [
      "Alexandria",
      "Aswan",
      "Asyut",
      "Beheira",
      "Beni Suef",
      "Cairo",
      "Dakahlia",
      "Damietta",
      "Faiyum",
      "Gharbia",
      "Giza",
      "Ismailia",
      "Kafr El-Sheikh",
      "Luxor",
      "Matrouh",
      "Minya",
      "Monufia",
      "New Valley",
      "North Sinai",
      "Port Said",
      "Qalyubia",
      "Qena",
      "Red Sea",
      "Sharqia",
      "Sohag",
      "South Sinai",
      "Suez"
    ]
  },
  {
    "name": "El Salvador",
    "code": "SV",
    "dial_code": "+503",
    "flag": "🇸🇻",
    "states": [
      "Ahuachapán",
      "Cabañas",
      "Chalatenango",
      "Cuscatlán",
      "La Libertad",
      "La Paz",
      "La Unión ",
      "Morazán",
      "San Miguel",
      "San Salvador",
      "San Vicente",
      "Santa Ana",
      "Sonsonate",
      "Usulután"
    ]
  },
  {
    "name": "Equatorial Guinea",
    "code": "GQ",
    "dial_code": "+240",
    "flag": "🇬🇶",
    "states": [
      "Annobón",
      "Bioko Norte",
      "Bioko Sur",
      "Centro Sur",
      "Insular",
      "Kié-Ntem",
      "Litoral",
      "Río Muni",
      "Wele-Nzas"
    ]
  },
  {
    "name": "Eritrea",
    "code": "ER",
    "dial_code": "+291",
    "flag": "🇪🇷",
    "states": [
      "Anseba",
      "Debub",
      "Gash-Barka",
      "Maekel",
      "Northern Red Sea",
      "Southern Red Sea"
    ]
  },
  {
    "name": "Estonia",
    "code": "EE",
    "dial_code": "+372",
    "flag": "🇪🇪",
    "states": [
      "Harju",
      "Hiiu",
      "Ida-Viru",
      "Järva",
      "Jõgeva",
      "Lääne",
      "Lääne-Viru",
      "Pärnu",
      "Põlva",
      "Rapla",
      "Saare",
      "Tartu",
      "Valga",
      "Viljandi",
      "Võru"
    ]
  },
  {
    "name": "Eswatini",
    "code": "SZ",
    "dial_code": "+268",
    "flag": "🇸🇿",
    "states": [
      "Hhohho",
      "Lubombo",
      "Manzini",
      "Shiselweni"
    ]
  },
  {
    "name": "Ethiopia",
    "code": "ET",
    "dial_code": "+251",
    "flag": "🇪🇹",
    "states": [
      "Addis Ababa",
      "Afar",
      "Amhara",
      "Benishangul-Gumuz",
      "Dire Dawa",
      "Gambela",
      "Harari",
      "Oromia",
      "Somali",
      "Southern Nations, Nationalities, and Peoples'",
      "Tigray"
    ]
  },
  {
    "name": "Falkland Islands",
    "code": "FK",
    "dial_code": "+500",
    "flag": "🇫🇰",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Faroe Islands",
    "code": "FO",
    "dial_code": "+298",
    "flag": "🇫🇴",
    "states": [
      "Eysturoy",
      "Northern Isles",
      "Sandoy",
      "Streymoy",
      "Suðuroy",
      "Vágar"
    ]
  },
  {
    "name": "Fiji Islands",
    "code": "FJ",
    "dial_code": "+679",
    "flag": "🇫🇯",
    "states": [
      "Ba",
      "Bua",
      "Cakaudrove",
      "Central",
      "Eastern",
      "Kadavu",
      "Lau",
      "Lomaiviti",
      "Macuata",
      "Nadroga-Navosa",
      "Naitasiri",
      "Namosi",
      "Northern",
      "Ra",
      "Rewa",
      "Rotuma",
      "Serua",
      "Tailevu",
      "Western"
    ]
  },
  {
    "name": "Finland",
    "code": "FI",
    "dial_code": "+358",
    "flag": "🇫🇮",
    "states": [
      "Åland Islands",
      "Central Finland",
      "Central Ostrobothnia",
      "Finland Proper",
      "Kainuu",
      "Kymenlaakso",
      "Lapland",
      "North Karelia",
      "Northern Ostrobothnia",
      "Northern Savonia",
      "Ostrobothnia",
      "Päijänne Tavastia",
      "Pirkanmaa",
      "Satakunta",
      "South Karelia",
      "Southern Ostrobothnia",
      "Southern Savonia",
      "Tavastia Proper",
      "Uusimaa"
    ]
  },
  {
    "name": "France",
    "code": "FR",
    "dial_code": "+33",
    "flag": "🇫🇷",
    "states": [
      "Ain",
      "Aisne",
      "Allier",
      "Alpes-de-Haute-Provence",
      "Alpes-Maritimes",
      "Alsace",
      "Ardèche",
      "Ardennes",
      "Ariège",
      "Aube",
      "Aude",
      "Auvergne-Rhône-Alpes",
      "Aveyron",
      "Bas-Rhin",
      "Bouches-du-Rhône",
      "Bourgogne-Franche-Comté",
      "Bretagne",
      "Calvados",
      "Cantal",
      "Centre-Val de Loire",
      "Charente",
      "Charente-Maritime",
      "Cher",
      "Clipperton",
      "Corrèze",
      "Corse",
      "Corse-du-Sud",
      "Côte-d'Or",
      "Côtes-d'Armor",
      "Creuse",
      "Deux-Sèvres",
      "Dordogne",
      "Doubs",
      "Drôme",
      "Essonne",
      "Eure",
      "Eure-et-Loir",
      "Finistère",
      "French Guiana",
      "French Polynesia",
      "French Southern and Antarctic Lands",
      "Gard",
      "Gers",
      "Gironde",
      "Grand-Est",
      "Guadeloupe",
      "Haut-Rhin",
      "Haute-Corse",
      "Haute-Garonne",
      "Haute-Loire",
      "Haute-Marne",
      "Haute-Saône",
      "Haute-Savoie",
      "Haute-Vienne",
      "Hautes-Alpes",
      "Hautes-Pyrénées",
      "Hauts-de-France",
      "Hauts-de-Seine",
      "Hérault",
      "Île-de-France",
      "Ille-et-Vilaine",
      "Indre",
      "Indre-et-Loire",
      "Isère",
      "Jura",
      "La Réunion",
      "Landes",
      "Loir-et-Cher",
      "Loire",
      "Loire-Atlantique",
      "Loiret",
      "Lot",
      "Lot-et-Garonne",
      "Lozère",
      "Maine-et-Loire",
      "Manche",
      "Marne",
      "Martinique",
      "Mayenne",
      "Mayotte",
      "Métropole de Lyon",
      "Meurthe-et-Moselle",
      "Meuse",
      "Morbihan",
      "Moselle",
      "Nièvre",
      "Nord",
      "Normandie",
      "Nouvelle-Aquitaine",
      "Occitanie",
      "Oise",
      "Orne",
      "Paris",
      "Pas-de-Calais",
      "Pays-de-la-Loire",
      "Provence-Alpes-Côte-d’Azur",
      "Puy-de-Dôme",
      "Pyrénées-Atlantiques",
      "Pyrénées-Orientales",
      "Rhône",
      "Saint Pierre and Miquelon",
      "Saint-Barthélemy",
      "Saint-Martin",
      "Saône-et-Loire",
      "Sarthe",
      "Savoie",
      "Seine-et-Marne",
      "Seine-Maritime",
      "Seine-Saint-Denis",
      "Somme",
      "Tarn",
      "Tarn-et-Garonne",
      "Territoire de Belfort",
      "Val-d'Oise",
      "Val-de-Marne",
      "Var",
      "Vaucluse",
      "Vendée",
      "Vienne",
      "Vosges",
      "Wallis and Futuna",
      "Yonne",
      "Yvelines"
    ]
  },
  {
    "name": "French Guiana",
    "code": "GF",
    "dial_code": "+594",
    "flag": "🇬🇫",
    "states": [
      "No states"
    ]
  },
  {
    "name": "French Polynesia",
    "code": "PF",
    "dial_code": "+689",
    "flag": "🇵🇫",
    "states": [
      "Austral Islands",
      "Leeward Islands",
      "Marquesas Islands",
      "Tuamotu-Gambier",
      "Windward Islands"
    ]
  },
  {
    "name": "French Southern Territories",
    "code": "TF",
    "dial_code": "+262",
    "flag": "🇹🇫",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Gabon",
    "code": "GA",
    "dial_code": "+241",
    "flag": "🇬🇦",
    "states": [
      "Estuaire",
      "Haut-Ogooué",
      "Moyen-Ogooué",
      "Ngounié",
      "Nyanga",
      "Ogooué-Ivindo",
      "Ogooué-Lolo",
      "Ogooué-Maritime",
      "Woleu-Ntem"
    ]
  },
  {
    "name": "Georgia",
    "code": "GE",
    "dial_code": "+995",
    "flag": "🇬🇪",
    "states": [
      "Abkhazia",
      "Adjara",
      "Guria",
      "Imereti",
      "Kakheti",
      "Kvemo Kartli",
      "Mtskheta-Mtianeti",
      "Racha-Lechkhumi and Kvemo Svaneti",
      "Samegrelo-Zemo Svaneti",
      "Samtskhe-Javakheti",
      "Shida Kartli",
      "Tbilisi"
    ]
  },
  {
    "name": "Germany",
    "code": "DE",
    "dial_code": "+49",
    "flag": "🇩🇪",
    "states": [
      "Baden-Württemberg",
      "Bavaria",
      "Berlin",
      "Brandenburg",
      "Bremen",
      "Hamburg",
      "Hessen",
      "Lower Saxony",
      "Mecklenburg-Vorpommern",
      "North Rhine-Westphalia",
      "Rhineland-Palatinate",
      "Saarland",
      "Saxony",
      "Saxony-Anhalt",
      "Schleswig-Holstein",
      "Thuringia"
    ]
  },
  {
    "name": "Ghana",
    "code": "GH",
    "dial_code": "+233",
    "flag": "🇬🇭",
    "states": [
      "Ahafo",
      "Ashanti",
      "Bono",
      "Bono East",
      "Central",
      "Eastern",
      "Greater Accra",
      "North East",
      "Northern",
      "Oti",
      "Savannah",
      "Upper East",
      "Upper West",
      "Volta",
      "Western",
      "Western North"
    ]
  },
  {
    "name": "Gibraltar",
    "code": "GI",
    "dial_code": "+350",
    "flag": "🇬🇮",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Greece",
    "code": "GR",
    "dial_code": "+30",
    "flag": "🇬🇷",
    "states": [
      "Achaea",
      "Aetolia-Acarnania",
      "Arcadia",
      "Argolis",
      "Attica",
      "Boeotia",
      "Central Greece",
      "Central Macedonia",
      "Chania",
      "Corfu",
      "Corinthia",
      "Crete",
      "Drama",
      "East Attica",
      "East Macedonia and Thrace",
      "Epirus",
      "Euboea",
      "Grevena",
      "Imathia ",
      "Ioannina",
      "Ionian Islands",
      "Karditsa",
      "Kastoria",
      "Kefalonia",
      "Kilkis",
      "Kozani",
      "Laconia",
      "Larissa",
      "Lefkada",
      "Pella",
      "Peloponnese",
      "Phthiotis",
      "Preveza",
      "Serres",
      "South Aegean",
      "Thessaloniki",
      "West Greece",
      "West Macedonia"
    ]
  },
  {
    "name": "Greenland",
    "code": "GL",
    "dial_code": "+299",
    "flag": "🇬🇱",
    "states": [
      "Avannaata",
      "Kujalleq",
      "Qeqertalik",
      "Qeqqata",
      "Sermersooq"
    ]
  },
  {
    "name": "Grenada",
    "code": "GD",
    "dial_code": "+1",
    "flag": "🇬🇩",
    "states": [
      "Carriacou",
      "Saint Andrew",
      "Saint David",
      "Saint George",
      "Saint John",
      "Saint Mark",
      "Saint Patrick"
    ]
  },
  {
    "name": "Guadeloupe",
    "code": "GP",
    "dial_code": "+590",
    "flag": "🇬🇵",
    "states": [
      "Basse-Terre",
      "Pointe-à-Pitre"
    ]
  },
  {
    "name": "Guam",
    "code": "GU",
    "dial_code": "+1",
    "flag": "🇬🇺",
    "states": [
      "Agana Heights",
      "Asan-Maina",
      "Barrigada",
      "Chalan Pago-Ordot",
      "Dededo",
      "Hågat",
      "Hagåtña",
      "Inarajan (Inalåhan)",
      "Mangilao",
      "Merizo (Malesso)",
      "Mongmong-Toto-Maite",
      "Piti",
      "Santa Rita (Sånta Rita-Sumai)",
      "Sinajana",
      "Talofofo (Talo'fo'fo)",
      "Tamuning",
      "Umatac (Humåtak)",
      "Yigo",
      "Yona"
    ]
  },
  {
    "name": "Guatemala",
    "code": "GT",
    "dial_code": "+502",
    "flag": "🇬🇹",
    "states": [
      "Alta Verapaz ",
      "Baja Verapaz ",
      "Chimaltenango ",
      "Chiquimula ",
      "El Progreso ",
      "Escuintla ",
      "Guatemala ",
      "Huehuetenango ",
      "Izabal ",
      "Jalapa ",
      "Jutiapa ",
      "Petén ",
      "Quetzaltenango ",
      "Quiché ",
      "Retalhuleu ",
      "Sacatepéquez ",
      "San Marcos ",
      "Santa Rosa ",
      "Sololá ",
      "Suchitepéquez ",
      "Totonicapán ",
      "Zacapa"
    ]
  },
  {
    "name": "Guernsey",
    "code": "GG",
    "dial_code": "+44",
    "flag": "🇬🇬",
    "states": [
      "Alderney",
      "Castel",
      "Forest",
      "Sark",
      "St Andrew",
      "St Martin",
      "St Peter Port",
      "St Pierre du Bois",
      "St Sampson",
      "St Saviour",
      "Torteval",
      "Vale"
    ]
  },
  {
    "name": "Guinea",
    "code": "GN",
    "dial_code": "+224",
    "flag": "🇬🇳",
    "states": [
      "Beyla",
      "Boffa",
      "Boké",
      "Boké",
      "Conakry",
      "Coyah",
      "Dabola",
      "Dalaba",
      "Dinguiraye",
      "Dubréka",
      "Faranah",
      "Faranah",
      "Forécariah",
      "Fria",
      "Gaoual",
      "Guéckédou",
      "Kankan",
      "Kankan",
      "Kérouané",
      "Kindia",
      "Kindia",
      "Kissidougou",
      "Koubia",
      "Koundara",
      "Kouroussa",
      "Labé",
      "Labé",
      "Lélouma",
      "Lola",
      "Macenta",
      "Mali",
      "Mamou",
      "Mamou",
      "Mandiana",
      "Nzérékoré",
      "Nzérékoré",
      "Pita",
      "Siguiri",
      "Télimélé",
      "Tougué",
      "Yomou"
    ]
  },
  {
    "name": "Guinea-Bissau",
    "code": "GW",
    "dial_code": "+245",
    "flag": "🇬🇼",
    "states": [
      "Bafatá",
      "Biombo",
      "Bolama",
      "Cacheu",
      "Gabú",
      "Leste",
      "Norte",
      "Oio",
      "Quinara",
      "Sul",
      "Tombali"
    ]
  },
  {
    "name": "Guyana",
    "code": "GY",
    "dial_code": "+592",
    "flag": "🇬🇾",
    "states": [
      "Barima-Waini",
      "Cuyuni-Mazaruni",
      "Demerara-Mahaica",
      "East Berbice-Corentyne",
      "Essequibo Islands-West Demerara",
      "Mahaica-Berbice",
      "Pomeroon-Supenaam",
      "Potaro-Siparuni",
      "Upper Demerara-Berbice",
      "Upper Takutu-Upper Essequibo"
    ]
  },
  {
    "name": "Haiti",
    "code": "HT",
    "dial_code": "+509",
    "flag": "🇭🇹",
    "states": [
      "Artibonite",
      "Centre",
      "Grand'Anse",
      "Nippes",
      "Nord",
      "Nord-Est",
      "Nord-Ouest",
      "Ouest",
      "Sud",
      "Sud-Est"
    ]
  },
  {
    "name": "Heard Island and McDonald Islands",
    "code": "HM",
    "dial_code": "+672",
    "flag": "🇭🇲",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Honduras",
    "code": "HN",
    "dial_code": "+504",
    "flag": "🇭🇳",
    "states": [
      "Atlántida",
      "Bay Islands",
      "Choluteca",
      "Colón",
      "Comayagua",
      "Copán",
      "Cortés",
      "El Paraíso",
      "Francisco Morazán",
      "Gracias a Dios",
      "Intibucá",
      "La Paz",
      "Lempira",
      "Ocotepeque",
      "Olancho",
      "Santa Bárbara",
      "Valle",
      "Yoro"
    ]
  },
  {
    "name": "Hong Kong S.A.R.",
    "code": "HK",
    "dial_code": "+852",
    "flag": "🇭🇰",
    "states": [
      "Central and Western",
      "Eastern",
      "Islands",
      "Kowloon City",
      "Kwai Tsing",
      "Kwun Tong",
      "North",
      "Sai Kung",
      "Sha Tin",
      "Sham Shui Po",
      "Southern",
      "Tai Po",
      "Tsuen Wan",
      "Tuen Mun",
      "Wan Chai",
      "Wong Tai Sin",
      "Yau Tsim Mong",
      "Yuen Long"
    ]
  },
  {
    "name": "Hungary",
    "code": "HU",
    "dial_code": "+36",
    "flag": "🇭🇺",
    "states": [
      "Bács-Kiskun",
      "Baranya",
      "Békés",
      "Békéscsaba",
      "Borsod-Abaúj-Zemplén",
      "Budapest",
      "Csongrád County",
      "Debrecen",
      "Dunaújváros",
      "Eger",
      "Érd",
      "Fejér County",
      "Győr",
      "Győr-Moson-Sopron County",
      "Hajdú-Bihar County",
      "Heves County",
      "Hódmezővásárhely",
      "Jász-Nagykun-Szolnok County",
      "Kaposvár",
      "Kecskemét",
      "Komárom-Esztergom",
      "Miskolc",
      "Nagykanizsa",
      "Nógrád County",
      "Nyíregyháza",
      "Pécs",
      "Pest County",
      "Salgótarján",
      "Somogy County",
      "Sopron",
      "Szabolcs-Szatmár-Bereg County",
      "Szeged",
      "Székesfehérvár",
      "Szekszárd",
      "Szolnok",
      "Szombathely",
      "Tatabánya",
      "Tolna County",
      "Vas County",
      "Veszprém",
      "Veszprém County",
      "Zala County",
      "Zalaegerszeg"
    ]
  },
  {
    "name": "Iceland",
    "code": "IS",
    "dial_code": "+354",
    "flag": "🇮🇸",
    "states": [
      "Capital",
      "Eastern",
      "Northeastern",
      "Northwestern",
      "Southern",
      "Southern Peninsula",
      "Western",
      "Westfjords"
    ]
  },
  {
    "name": "India",
    "code": "IN",
    "dial_code": "+91",
    "flag": "🇮🇳",
    "states": [
      "Andaman and Nicobar Islands",
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chandigarh",
      "Chhattisgarh",
      "Dadra and Nagar Haveli and Daman and Diu",
      "Delhi",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jammu and Kashmir",
      "Jharkhand",
      "Karnataka",
      "Kerala",
      "Ladakh",
      "Lakshadweep",
      "Madhya Pradesh",
      "Maharashtra",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Puducherry",
      "Punjab",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Telangana",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal"
    ]
  },
  {
    "name": "Indonesia",
    "code": "ID",
    "dial_code": "+62",
    "flag": "🇮🇩",
    "states": [
      "Aceh",
      "Bali",
      "Banten",
      "Bengkulu",
      "DI Yogyakarta",
      "DKI Jakarta",
      "Gorontalo",
      "Jambi",
      "Jawa Barat",
      "Jawa Tengah",
      "Jawa Timur",
      "Kalimantan Barat",
      "Kalimantan Selatan",
      "Kalimantan Tengah",
      "Kalimantan Timur",
      "Kalimantan Utara",
      "Kepulauan Bangka Belitung",
      "Kepulauan Riau",
      "Lampung",
      "Maluku",
      "Maluku Utara",
      "Nusa Tenggara Barat",
      "Nusa Tenggara Timur",
      "Papua",
      "Papua Barat",
      "Papua Barat Daya",
      "Papua Pegunungan",
      "Papua Selatan",
      "Papua Tengah",
      "Riau",
      "Sulawesi Barat",
      "Sulawesi Selatan",
      "Sulawesi Tengah",
      "Sulawesi Tenggara",
      "Sulawesi Utara",
      "Sumatera Barat",
      "Sumatera Selatan",
      "Sumatera Utara"
    ]
  },
  {
    "name": "Iran",
    "code": "IR",
    "dial_code": "+98",
    "flag": "🇮🇷",
    "states": [
      "Alborz",
      "Ardabil",
      "Bushehr",
      "Chaharmahal and Bakhtiari",
      "East Azerbaijan",
      "Fars",
      "Gilan",
      "Golestan",
      "Hamadan",
      "Hormozgan",
      "Ilam",
      "Isfahan",
      "Kerman",
      "Kermanshah",
      "Khuzestan",
      "Kohgiluyeh and Boyer-Ahmad",
      "Kurdistan",
      "Lorestan",
      "Markazi",
      "Mazandaran",
      "North Khorasan",
      "Qazvin",
      "Qom",
      "Razavi Khorasan",
      "Semnan",
      "Sistan and Baluchestan",
      "South Khorasan",
      "Tehran",
      "West Azarbaijan",
      "Yazd",
      "Zanjan"
    ]
  },
  {
    "name": "Iraq",
    "code": "IQ",
    "dial_code": "+964",
    "flag": "🇮🇶",
    "states": [
      "Al Anbar",
      "Al Muthanna",
      "Al-Qādisiyyah",
      "Babylon",
      "Baghdad",
      "Basra",
      "Dhi Qar",
      "Diyala",
      "Dohuk",
      "Erbil",
      "Karbala",
      "Kirkuk",
      "Maysan",
      "Najaf",
      "Nineveh",
      "Saladin",
      "Sulaymaniyah",
      "Wasit"
    ]
  },
  {
    "name": "Ireland",
    "code": "IE",
    "dial_code": "+353",
    "flag": "🇮🇪",
    "states": [
      "Carlow",
      "Cavan",
      "Clare",
      "Connacht",
      "Cork",
      "Donegal",
      "Dublin",
      "Galway",
      "Kerry",
      "Kildare",
      "Kilkenny",
      "Laois",
      "Leinster",
      "Leitrim",
      "Limerick",
      "Longford",
      "Louth",
      "Mayo",
      "Meath",
      "Monaghan",
      "Munster",
      "Offaly",
      "Roscommon",
      "Sligo",
      "Tipperary",
      "Ulster",
      "Waterford",
      "Westmeath",
      "Wexford",
      "Wicklow"
    ]
  },
  {
    "name": "Israel",
    "code": "IL",
    "dial_code": "+972",
    "flag": "🇮🇱",
    "states": [
      "Central",
      "Haifa",
      "Jerusalem",
      "Northern",
      "Southern",
      "Tel Aviv"
    ]
  },
  {
    "name": "Italy",
    "code": "IT",
    "dial_code": "+39",
    "flag": "🇮🇹",
    "states": [
      "Abruzzo",
      "Agrigento",
      "Alessandria",
      "Ancona",
      "Aosta Valley",
      "Apulia",
      "Arezzo",
      "Ascoli Piceno",
      "Asti",
      "Avellino",
      "Barletta-Andria-Trani",
      "Basilicata",
      "Belluno",
      "Benevento",
      "Bergamo",
      "Biella",
      "Brescia",
      "Brindisi",
      "Calabria",
      "Caltanissetta",
      "Campania",
      "Campobasso",
      "Caserta",
      "Catanzaro",
      "Chieti",
      "Como",
      "Cosenza",
      "Cremona",
      "Crotone",
      "Cuneo",
      "Emilia-Romagna",
      "Enna",
      "Fermo",
      "Ferrara",
      "Foggia",
      "Forlì-Cesena",
      "Friuli–Venezia Giulia",
      "Frosinone",
      "Gorizia",
      "Grosseto",
      "Imperia",
      "Isernia",
      "L'Aquila",
      "La Spezia",
      "Latina",
      "Lazio",
      "Lecce",
      "Lecco",
      "Liguria",
      "Livorno",
      "Lodi",
      "Lombardy",
      "Lucca",
      "Macerata",
      "Mantua",
      "Marche",
      "Massa and Carrara",
      "Matera",
      "Modena",
      "Molise",
      "Monza and Brianza",
      "Novara",
      "Nuoro",
      "Oristano",
      "Padua",
      "Palermo",
      "Parma",
      "Pavia",
      "Perugia",
      "Pesaro and Urbino",
      "Pescara",
      "Piacenza",
      "Piedmont",
      "Pisa",
      "Pistoia",
      "Pordenone",
      "Potenza",
      "Prato",
      "Ragusa",
      "Ravenna",
      "Reggio Emilia",
      "Rieti",
      "Rimini",
      "Rovigo",
      "Salerno",
      "Sardinia",
      "Sassari",
      "Savona",
      "Sicily",
      "Siena",
      "Siracusa",
      "Sondrio",
      "South Sardinia",
      "Taranto",
      "Teramo",
      "Terni",
      "Trapani",
      "Trentino-South Tyrol",
      "Treviso",
      "Trieste",
      "Tuscany",
      "Udine",
      "Umbria",
      "Varese",
      "Veneto",
      "Verbano-Cusio-Ossola",
      "Vercelli",
      "Verona",
      "Vibo Valentia",
      "Vicenza",
      "Viterbo"
    ]
  },
  {
    "name": "Jamaica",
    "code": "JM",
    "dial_code": "+1",
    "flag": "🇯🇲",
    "states": [
      "Clarendon",
      "Hanover",
      "Kingston",
      "Manchester",
      "Portland",
      "Saint Andrew",
      "Saint Ann",
      "Saint Catherine",
      "Saint Elizabeth",
      "Saint James",
      "Saint Mary",
      "Saint Thomas",
      "Trelawny",
      "Westmoreland"
    ]
  },
  {
    "name": "Japan",
    "code": "JP",
    "dial_code": "+81",
    "flag": "🇯🇵",
    "states": [
      "Aichi",
      "Akita",
      "Aomori",
      "Chiba",
      "Ehime",
      "Fukui",
      "Fukuoka",
      "Fukushima",
      "Gifu",
      "Gunma",
      "Hiroshima",
      "Hokkaidō",
      "Hyōgo",
      "Ibaraki",
      "Ishikawa",
      "Iwate",
      "Kagawa",
      "Kagoshima",
      "Kanagawa",
      "Kōchi",
      "Kumamoto",
      "Kyōto",
      "Mie",
      "Miyagi",
      "Miyazaki",
      "Nagano",
      "Nagasaki",
      "Nara",
      "Niigata",
      "Ōita",
      "Okayama",
      "Okinawa",
      "Ōsaka",
      "Saga",
      "Saitama",
      "Shiga",
      "Shimane",
      "Shizuoka",
      "Tochigi",
      "Tokushima",
      "Tokyo",
      "Tottori",
      "Toyama",
      "Wakayama",
      "Yamagata",
      "Yamaguchi",
      "Yamanashi"
    ]
  },
  {
    "name": "Jersey",
    "code": "JE",
    "dial_code": "+44",
    "flag": "🇯🇪",
    "states": [
      "Grouville",
      "St Brelade",
      "St Clement",
      "St Helier",
      "St John",
      "St Lawrence",
      "St Martin",
      "St Mary",
      "St Ouen",
      "St Peter",
      "St Saviour",
      "Trinity"
    ]
  },
  {
    "name": "Jordan",
    "code": "JO",
    "dial_code": "+962",
    "flag": "🇯🇴",
    "states": [
      "Ajloun",
      "Amman",
      "Aqaba",
      "Balqa",
      "Irbid",
      "Jerash",
      "Karak",
      "Ma'an",
      "Madaba",
      "Mafraq",
      "Tafilah",
      "Zarqa"
    ]
  },
  {
    "name": "Kazakhstan",
    "code": "KZ",
    "dial_code": "+7",
    "flag": "🇰🇿",
    "states": [
      "Abai",
      "Akmola",
      "Aktobe",
      "Almaty",
      "Almaty",
      "Astana",
      "Atyrau",
      "East Kazakhstan",
      "Jambyl",
      "Jetisu",
      "Karaganda",
      "Kostanay",
      "Kyzylorda",
      "Mangystau",
      "North Kazakhstan",
      "Pavlodar",
      "Shymkent",
      "Turkistan",
      "Ulytau",
      "West Kazakhstan"
    ]
  },
  {
    "name": "Kenya",
    "code": "KE",
    "dial_code": "+254",
    "flag": "🇰🇪",
    "states": [
      "Baringo",
      "Bomet",
      "Bungoma",
      "Busia",
      "Elgeyo-Marakwet",
      "Embu",
      "Garissa",
      "Homa Bay",
      "Isiolo",
      "Kajiado",
      "Kakamega",
      "Kericho",
      "Kiambu",
      "Kilifi",
      "Kirinyaga",
      "Kisii",
      "Kisumu",
      "Kitui",
      "Kwale",
      "Laikipia",
      "Lamu",
      "Machakos",
      "Makueni",
      "Mandera",
      "Marsabit",
      "Meru",
      "Migori",
      "Mombasa",
      "Murang'a",
      "Nairobi City",
      "Nakuru",
      "Nandi",
      "Narok",
      "Nyamira",
      "Nyandarua",
      "Nyeri",
      "Samburu",
      "Siaya",
      "Taita–Taveta",
      "Tana River",
      "Tharaka-Nithi",
      "Trans Nzoia",
      "Turkana",
      "Uasin Gishu",
      "Vihiga",
      "Wajir",
      "West Pokot"
    ]
  },
  {
    "name": "Kiribati",
    "code": "KI",
    "dial_code": "+686",
    "flag": "🇰🇮",
    "states": [
      "Gilbert",
      "Line",
      "Phoenix"
    ]
  },
  {
    "name": "Kosovo",
    "code": "XK",
    "dial_code": "+383",
    "flag": "🇽🇰",
    "states": [
      "Ferizaj",
      "Gjakove",
      "Gjilan",
      "Mitrovica",
      "Peja",
      "Pristina",
      "Prizren"
    ]
  },
  {
    "name": "Kuwait",
    "code": "KW",
    "dial_code": "+965",
    "flag": "🇰🇼",
    "states": [
      "Al Ahmadi",
      "Al Asimah",
      "Al Farwaniyah",
      "Al Jahra",
      "Hawalli",
      "Mubarak Al-Kabeer"
    ]
  },
  {
    "name": "Kyrgyzstan",
    "code": "KG",
    "dial_code": "+996",
    "flag": "🇰🇬",
    "states": [
      "Batken",
      "Bishkek",
      "Chuy",
      "Issyk-Kul",
      "Jalal-Abad",
      "Naryn",
      "Osh",
      "Osh",
      "Talas"
    ]
  },
  {
    "name": "Laos",
    "code": "LA",
    "dial_code": "+856",
    "flag": "🇱🇦",
    "states": [
      "Attapeu",
      "Bokeo",
      "Bolikhamsai",
      "Champasak",
      "Houaphanh",
      "Khammouane",
      "Luang Namtha",
      "Luang Prabang",
      "Oudomxay",
      "Phongsaly",
      "Sainyabuli",
      "Salavan",
      "Savannakhet",
      "Sekong",
      "Vientiane",
      "Vientiane",
      "Xaisomboun",
      "Xiangkhouang"
    ]
  },
  {
    "name": "Latvia",
    "code": "LV",
    "dial_code": "+371",
    "flag": "🇱🇻",
    "states": [
      "Ādaži",
      "Aizkraukle",
      "Alūksne",
      "Augšdaugava",
      "Balvi",
      "Bauska",
      "Cēsis",
      "Daugavpils",
      "Dienvidkurzemes",
      "Dobele",
      "Gulbene",
      "Jēkabpils",
      "Jelgava",
      "Jelgava",
      "Jūrmala",
      "Ķekava",
      "Krāslava",
      "Kuldīga",
      "Liepāja",
      "Limbaži",
      "Līvāni",
      "Ludza",
      "Madona",
      "Mārupe",
      "Ogre",
      "Olaine",
      "Preiļi",
      "Rēzekne",
      "Rēzekne",
      "Riga",
      "Ropaži",
      "Salaspils",
      "Saldus",
      "Saulkrasti",
      "Sigulda",
      "Smiltene",
      "Talsi",
      "Tukums",
      "Valka",
      "Valmiera",
      "Varakļāni",
      "Ventspils",
      "Ventspils"
    ]
  },
  {
    "name": "Lebanon",
    "code": "LB",
    "dial_code": "+961",
    "flag": "🇱🇧",
    "states": [
      "Akkar",
      "Baalbek-Hermel",
      "Beirut",
      "Beqaa",
      "Mount Lebanon",
      "Nabatieh",
      "North",
      "South"
    ]
  },
  {
    "name": "Lesotho",
    "code": "LS",
    "dial_code": "+266",
    "flag": "🇱🇸",
    "states": [
      "Berea",
      "Butha-Buthe",
      "Leribe",
      "Mafeteng",
      "Maseru",
      "Mohale's Hoek",
      "Mokhotlong",
      "Qacha's Nek",
      "Quthing",
      "Thaba-Tseka"
    ]
  },
  {
    "name": "Liberia",
    "code": "LR",
    "dial_code": "+231",
    "flag": "🇱🇷",
    "states": [
      "Bomi",
      "Bong",
      "Gbarpolu",
      "Grand Bassa",
      "Grand Cape Mount",
      "Grand Gedeh",
      "Grand Kru",
      "Lofa",
      "Margibi",
      "Maryland",
      "Montserrado",
      "Nimba",
      "River Cess",
      "River Gee",
      "Sinoe"
    ]
  },
  {
    "name": "Libya",
    "code": "LY",
    "dial_code": "+218",
    "flag": "🇱🇾",
    "states": [
      "Al Wahat",
      "Benghazi",
      "Derna",
      "Ghat",
      "Jabal al Akhdar",
      "Jabal al Gharbi",
      "Jafara",
      "Jufra",
      "Kufra",
      "Marj",
      "Misrata",
      "Murqub",
      "Murzuq",
      "Nalut",
      "Nuqat al Khams",
      "Sabha",
      "Sirte",
      "Tripoli",
      "Wadi al Hayaa",
      "Wadi al Shatii",
      "Zawiya"
    ]
  },
  {
    "name": "Liechtenstein",
    "code": "LI",
    "dial_code": "+423",
    "flag": "🇱🇮",
    "states": [
      "Balzers",
      "Eschen",
      "Gamprin",
      "Mauren",
      "Planken",
      "Ruggell",
      "Schaan",
      "Schellenberg",
      "Triesen",
      "Triesenberg",
      "Vaduz"
    ]
  },
  {
    "name": "Lithuania",
    "code": "LT",
    "dial_code": "+370",
    "flag": "🇱🇹",
    "states": [
      "Akmenė",
      "Alytus",
      "Alytus",
      "Anykščiai",
      "Birštonas",
      "Biržai",
      "Druskininkai",
      "Elektrėnai",
      "Ignalina",
      "Jonava",
      "Joniškis",
      "Jurbarkas",
      "Kaišiadorys",
      "Kalvarija",
      "Kaunas",
      "Kaunas",
      "Kazlų Rūda",
      "Kėdainiai",
      "Kelmė",
      "Klaipėda",
      "Klaipėda",
      "Kretinga",
      "Kupiškis",
      "Lazdijai",
      "Marijampolė",
      "Marijampolė",
      "Mažeikiai",
      "Molėtai",
      "Neringa",
      "Pagėgiai",
      "Pakruojis",
      "Palanga",
      "Panevėžys",
      "Panevėžys",
      "Pasvalys",
      "Plungė",
      "Prienai",
      "Radviliškis",
      "Raseiniai",
      "Rietavas",
      "Rokiškis",
      "Šakiai",
      "Šalčininkai",
      "Šiauliai",
      "Šiauliai",
      "Šilalė ",
      "Šilutė",
      "Širvintos",
      "Skuodas",
      "Švenčionys",
      "Tauragė",
      "Tauragė",
      "Telšiai",
      "Telšiai",
      "Trakai",
      "Ukmergė",
      "Utena",
      "Utena",
      "Varėna",
      "Vilkaviškis",
      "Vilnius",
      "Vilnius",
      "Visaginas",
      "Zarasai"
    ]
  },
  {
    "name": "Luxembourg",
    "code": "LU",
    "dial_code": "+352",
    "flag": "🇱🇺",
    "states": [
      "Capellen",
      "Clervaux",
      "Diekirch",
      "Echternach",
      "Esch-sur-Alzette",
      "Grevenmacher",
      "Luxembourg ",
      "Mersch",
      "Redange",
      "Remich",
      "Vianden",
      "Wiltz"
    ]
  },
  {
    "name": "Macau S.A.R.",
    "code": "MO",
    "dial_code": "+853",
    "flag": "🇲🇴",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Madagascar",
    "code": "MG",
    "dial_code": "+261",
    "flag": "🇲🇬",
    "states": [
      "Antananarivo",
      "Antsiranana",
      "Fianarantsoa",
      "Mahajanga",
      "Toamasina",
      "Toliara"
    ]
  },
  {
    "name": "Malawi",
    "code": "MW",
    "dial_code": "+265",
    "flag": "🇲🇼",
    "states": [
      "Balaka",
      "Blantyre",
      "Central",
      "Chikwawa",
      "Chiradzulu",
      "Chitipa",
      "Dedza",
      "Dowa",
      "Karonga",
      "Kasungu",
      "Likoma",
      "Lilongwe",
      "Machinga",
      "Mangochi",
      "Mchinji",
      "Mulanje",
      "Mwanza",
      "Mzimba",
      "Neno",
      "Nkhata Bay",
      "Nkhotakota",
      "Northern",
      "Nsanje",
      "Ntcheu",
      "Ntchisi",
      "Phalombe",
      "Rumphi",
      "Salima",
      "Southern",
      "Thyolo",
      "Zomba"
    ]
  },
  {
    "name": "Malaysia",
    "code": "MY",
    "dial_code": "+60",
    "flag": "🇲🇾",
    "states": [
      "Johor",
      "Kedah",
      "Kelantan",
      "Kuala Lumpur",
      "Labuan",
      "Malacca",
      "Negeri Sembilan",
      "Pahang",
      "Penang",
      "Perak",
      "Perlis",
      "Putrajaya",
      "Sabah",
      "Sarawak",
      "Selangor",
      "Terengganu"
    ]
  },
  {
    "name": "Maldives",
    "code": "MV",
    "dial_code": "+960",
    "flag": "🇲🇻",
    "states": [
      "Addu",
      "Alif Alif",
      "Alif Dhaal",
      "Central",
      "Dhaalu",
      "Faafu",
      "Gaafu Alif",
      "Gaafu Dhaalu",
      "Gnaviyani",
      "Haa Alif",
      "Haa Dhaalu",
      "Kaafu",
      "Laamu",
      "Lhaviyani",
      "Malé",
      "Meemu",
      "Noonu",
      "North Central",
      "Raa",
      "Shaviyani",
      "South",
      "South Central",
      "Thaa",
      "Upper South",
      "Vaavu"
    ]
  },
  {
    "name": "Mali",
    "code": "ML",
    "dial_code": "+223",
    "flag": "🇲🇱",
    "states": [
      "Bamako",
      "Gao",
      "Kayes",
      "Kidal",
      "Koulikoro",
      "Ménaka",
      "Mopti",
      "Ségou",
      "Sikasso",
      "Taoudénit",
      "Tombouctou"
    ]
  },
  {
    "name": "Malta",
    "code": "MT",
    "dial_code": "+356",
    "flag": "🇲🇹",
    "states": [
      "Attard",
      "Balzan",
      "Birgu",
      "Birkirkara",
      "Birżebbuġa",
      "Cospicua",
      "Dingli",
      "Fgura",
      "Floriana",
      "Fontana",
      "Għajnsielem",
      "Għarb",
      "Għargħur",
      "Għasri",
      "Għaxaq",
      "Gudja",
      "Gżira",
      "Ħamrun",
      "Iklin",
      "Kalkara",
      "Kerċem",
      "Kirkop",
      "Lija",
      "Luqa",
      "Marsa",
      "Marsaskala",
      "Marsaxlokk",
      "Mdina",
      "Mellieħa",
      "Mġarr",
      "Mosta",
      "Mqabba",
      "Msida",
      "Mtarfa",
      "Munxar",
      "Nadur",
      "Naxxar",
      "Paola",
      "Pembroke",
      "Pietà",
      "Qala",
      "Qormi",
      "Qrendi",
      "Rabat",
      "San Ġwann",
      "San Lawrenz",
      "Sannat",
      "Santa Luċija",
      "Santa Venera",
      "Senglea",
      "Siġġiewi",
      "Sliema",
      "St. Julian's",
      "St. Paul's Bay",
      "Swieqi",
      "Ta' Xbiex",
      "Tarxien",
      "Valletta",
      "Victoria",
      "Xagħra",
      "Xewkija",
      "Xgħajra",
      "Żabbar",
      "Żebbuġ Gozo",
      "Żebbuġ Malta",
      "Żejtun",
      "Żurrieq"
    ]
  },
  {
    "name": "Man (Isle of)",
    "code": "IM",
    "dial_code": "+44",
    "flag": "🇮🇲",
    "states": [
      "Ayre",
      "Garff",
      "Glenfaba",
      "Michael",
      "Middle",
      "Rushen"
    ]
  },
  {
    "name": "Marshall Islands",
    "code": "MH",
    "dial_code": "+692",
    "flag": "🇲🇭",
    "states": [
      "Ralik",
      "Ratak"
    ]
  },
  {
    "name": "Martinique",
    "code": "MQ",
    "dial_code": "+596",
    "flag": "🇲🇶",
    "states": [
      "Fort-de-France",
      "La Trinité",
      "Le Marin",
      "Saint-Pierre"
    ]
  },
  {
    "name": "Mauritania",
    "code": "MR",
    "dial_code": "+222",
    "flag": "🇲🇷",
    "states": [
      "Adrar",
      "Assaba",
      "Brakna",
      "Dakhlet Nouadhibou",
      "Gorgol",
      "Guidimaka",
      "Hodh Ech Chargui",
      "Hodh El Gharbi",
      "Inchiri",
      "Nouakchott-Nord",
      "Nouakchott-Ouest",
      "Nouakchott-Sud",
      "Tagant",
      "Tiris Zemmour",
      "Trarza"
    ]
  },
  {
    "name": "Mauritius",
    "code": "MU",
    "dial_code": "+230",
    "flag": "🇲🇺",
    "states": [
      "Agalega Islands",
      "Black River",
      "Flacq",
      "Grand Port",
      "Moka",
      "Pamplemousses",
      "Plaines Wilhems",
      "Port Louis",
      "Rivière du Rempart",
      "Rodrigues Island",
      "Saint Brandon Islands",
      "Savanne"
    ]
  },
  {
    "name": "Mayotte",
    "code": "YT",
    "dial_code": "+262",
    "flag": "🇾🇹",
    "states": [
      "Acoua",
      "Bandraboua",
      "Bandrélé",
      "Boueni",
      "Chiconi",
      "Chirongui",
      "Dembeni",
      "Dzaoudzi",
      "Kani Keli",
      "Koungou",
      "M'Tsangamouji",
      "Mamoudzou",
      "Mtsamboro",
      "Ouangani",
      "Pamandzi",
      "Sada",
      "Tsingoni"
    ]
  },
  {
    "name": "Mexico",
    "code": "MX",
    "dial_code": "+52",
    "flag": "🇲🇽",
    "states": [
      "Aguascalientes",
      "Baja California",
      "Baja California Sur",
      "Campeche",
      "Chiapas",
      "Chihuahua",
      "Ciudad de México",
      "Coahuila de Zaragoza",
      "Colima",
      "Durango",
      "Estado de México",
      "Guanajuato",
      "Guerrero",
      "Hidalgo",
      "Jalisco",
      "Michoacán de Ocampo",
      "Morelos",
      "Nayarit",
      "Nuevo León",
      "Oaxaca",
      "Puebla",
      "Querétaro",
      "Quintana Roo",
      "San Luis Potosí",
      "Sinaloa",
      "Sonora",
      "Tabasco",
      "Tamaulipas",
      "Tlaxcala",
      "Veracruz de Ignacio de la Llave",
      "Yucatán",
      "Zacatecas"
    ]
  },
  {
    "name": "Micronesia",
    "code": "FM",
    "dial_code": "+691",
    "flag": "🇫🇲",
    "states": [
      "Chuuk",
      "Kosrae",
      "Pohnpei",
      "Yap"
    ]
  },
  {
    "name": "Moldova",
    "code": "MD",
    "dial_code": "+373",
    "flag": "🇲🇩",
    "states": [
      "Anenii Noi",
      "Bălți",
      "Basarabeasca",
      "Bender",
      "Briceni",
      "Cahul",
      "Călărași",
      "Cantemir",
      "Căușeni",
      "Chișinău",
      "Cimișlia",
      "Criuleni",
      "Dondușeni",
      "Drochia",
      "Dubăsari",
      "Edineț",
      "Fălești",
      "Florești",
      "Gagauzia",
      "Glodeni",
      "Hîncești",
      "Ialoveni",
      "Nisporeni",
      "Ocnița",
      "Orhei",
      "Rezina",
      "Rîșcani",
      "Sîngerei",
      "Șoldănești",
      "Soroca",
      "Ștefan Vodă",
      "Strășeni",
      "Taraclia",
      "Telenești",
      "Transnistria",
      "Ungheni"
    ]
  },
  {
    "name": "Monaco",
    "code": "MC",
    "dial_code": "+377",
    "flag": "🇲🇨",
    "states": [
      "La Colle",
      "La Condamine",
      "Moneghetti"
    ]
  },
  {
    "name": "Mongolia",
    "code": "MN",
    "dial_code": "+976",
    "flag": "🇲🇳",
    "states": [
      "Arkhangai",
      "Bayan-Ölgii",
      "Bayankhongor",
      "Bulgan",
      "Darkhan-Uul",
      "Dornod",
      "Dornogovi",
      "Dundgovi",
      "Govi-Altai",
      "Govisümber",
      "Khentii",
      "Khovd",
      "Khövsgöl",
      "Ömnögovi",
      "Orkhon",
      "Övörkhangai",
      "Selenge",
      "Sükhbaatar",
      "Töv",
      "Ulaanbaatar",
      "Uvs",
      "Zavkhan"
    ]
  },
  {
    "name": "Montenegro",
    "code": "ME",
    "dial_code": "+382",
    "flag": "🇲🇪",
    "states": [
      "Andrijevica",
      "Bar",
      "Berane",
      "Bijelo Polje",
      "Budva",
      "Danilovgrad",
      "Gusinje",
      "Kolašin",
      "Kotor",
      "Mojkovac",
      "Nikšić",
      "Old Royal Capital Cetinje",
      "Petnjica",
      "Plav",
      "Pljevlja",
      "Plužine",
      "Podgorica",
      "Rožaje",
      "Šavnik",
      "Tivat",
      "Ulcinj",
      "Žabljak"
    ]
  },
  {
    "name": "Montserrat",
    "code": "MS",
    "dial_code": "+1",
    "flag": "🇲🇸",
    "states": [
      "Saint Anthony",
      "Saint Georges",
      "Saint Peter"
    ]
  },
  {
    "name": "Morocco",
    "code": "MA",
    "dial_code": "+212",
    "flag": "🇲🇦",
    "states": [
      "Agadir-Ida-Ou-Tanane",
      "Al Haouz",
      "Al Hoceïma",
      "Aousserd (EH)",
      "Assa-Zag (EH-partial)",
      "Azilal",
      "Béni Mellal",
      "Béni Mellal-Khénifra",
      "Benslimane",
      "Berkane",
      "Berrechid",
      "Boujdour (EH)",
      "Boulemane",
      "Casablanca",
      "Casablanca-Settat",
      "Chefchaouen",
      "Chichaoua",
      "Chtouka-Ait Baha",
      "Dakhla-Oued Ed-Dahab (EH)",
      "Drâa-Tafilalet",
      "Driouch",
      "El Hajeb",
      "El Jadida",
      "El Kelâa des Sraghna",
      "Errachidia",
      "Es-Semara (EH-partial)",
      "Essaouira",
      "Fahs-Anjra",
      "Fès",
      "Fès-Meknès",
      "Figuig",
      "Fquih Ben Salah",
      "Guelmim",
      "Guelmim-Oued Noun (EH-partial)",
      "Guercif",
      "Ifrane",
      "Inezgane-Ait Melloul",
      "Jerada",
      "Kénitra",
      "Khémisset",
      "Khénifra",
      "Khouribga",
      "L'Oriental",
      "Laâyoune (EH)",
      "Laâyoune-Sakia El Hamra (EH-partial)",
      "Larache",
      "M’diq-Fnideq",
      "Marrakech",
      "Marrakesh-Safi",
      "Médiouna",
      "Meknès",
      "Midelt",
      "Mohammadia",
      "Moulay Yacoub",
      "Nador",
      "Nouaceur",
      "Ouarzazate",
      "Oued Ed-Dahab (EH)",
      "Ouezzane",
      "Oujda-Angad",
      "Rabat",
      "Rabat-Salé-Kénitra",
      "Rehamna",
      "Safi",
      "Salé",
      "Sefrou",
      "Settat",
      "Sidi Bennour",
      "Sidi Ifni",
      "Sidi Kacem",
      "Sidi Slimane",
      "Skhirate-Témara",
      "Souss-Massa",
      "Tan-Tan (EH-partial)",
      "Tanger-Assilah",
      "Tanger-Tétouan-Al Hoceïma",
      "Taounate",
      "Taourirt",
      "Tarfaya (EH-partial)",
      "Taroudannt",
      "Tata",
      "Taza",
      "Tétouan",
      "Tinghir",
      "Tiznit",
      "Youssoufia",
      "Zagora"
    ]
  },
  {
    "name": "Mozambique",
    "code": "MZ",
    "dial_code": "+258",
    "flag": "🇲🇿",
    "states": [
      "Cabo Delgado",
      "Gaza",
      "Inhambane",
      "Manica",
      "Maputo",
      "Maputo",
      "Nampula",
      "Niassa",
      "Sofala",
      "Tete",
      "Zambezia"
    ]
  },
  {
    "name": "Myanmar",
    "code": "MM",
    "dial_code": "+95",
    "flag": "🇲🇲",
    "states": [
      "Ayeyarwady",
      "Bago",
      "Chin",
      "Kachin",
      "Kayah",
      "Kayin",
      "Magway",
      "Mandalay",
      "Mon State",
      "Naypyidaw",
      "Rakhine",
      "Sagaing",
      "Shan",
      "Tanintharyi",
      "Yangon"
    ]
  },
  {
    "name": "Namibia",
    "code": "NA",
    "dial_code": "+264",
    "flag": "🇳🇦",
    "states": [
      "Erongo",
      "Hardap",
      "Karas",
      "Kavango East",
      "Kavango West",
      "Khomas",
      "Kunene",
      "Ohangwena",
      "Omaheke",
      "Omusati",
      "Oshana",
      "Oshikoto",
      "Otjozondjupa",
      "Zambezi"
    ]
  },
  {
    "name": "Nauru",
    "code": "NR",
    "dial_code": "+674",
    "flag": "🇳🇷",
    "states": [
      "Aiwo",
      "Anabar",
      "Anetan",
      "Anibare",
      "Baiti",
      "Boe",
      "Buada",
      "Denigomodu",
      "Ewa",
      "Ijuw",
      "Meneng",
      "Nibok",
      "Uaboe",
      "Yaren"
    ]
  },
  {
    "name": "Nepal",
    "code": "NP",
    "dial_code": "+977",
    "flag": "🇳🇵",
    "states": [
      "Bagmati",
      "Gandaki",
      "Karnali",
      "Koshi",
      "Lumbini",
      "Madhesh",
      "Sudurpashchim"
    ]
  },
  {
    "name": "Netherlands",
    "code": "NL",
    "dial_code": "+31",
    "flag": "🇳🇱",
    "states": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "North Brabant",
      "North Holland",
      "Overijssel",
      "South Holland",
      "Utrecht",
      "Zeeland"
    ]
  },
  {
    "name": "New Caledonia",
    "code": "NC",
    "dial_code": "+687",
    "flag": "🇳🇨",
    "states": [
      "Loyalty Islands Province",
      "North Province",
      "South Province"
    ]
  },
  {
    "name": "New Zealand",
    "code": "NZ",
    "dial_code": "+64",
    "flag": "🇳🇿",
    "states": [
      "Auckland",
      "Bay of Plenty",
      "Canterbury",
      "Chatham Islands",
      "Gisborne",
      "Hawke's Bay",
      "Manawatu-Wanganui",
      "Marlborough",
      "Nelson",
      "Northland",
      "Otago",
      "Southland",
      "Taranaki",
      "Tasman",
      "Waikato",
      "Wellington",
      "West Coast"
    ]
  },
  {
    "name": "Nicaragua",
    "code": "NI",
    "dial_code": "+505",
    "flag": "🇳🇮",
    "states": [
      "Boaco",
      "Carazo",
      "Chinandega",
      "Chontales",
      "Estelí",
      "Granada",
      "Jinotega",
      "León",
      "Madriz",
      "Managua",
      "Masaya",
      "Matagalpa",
      "North Caribbean Coast",
      "Nueva Segovia",
      "Río San Juan",
      "Rivas",
      "South Caribbean Coast"
    ]
  },
  {
    "name": "Niger",
    "code": "NE",
    "dial_code": "+227",
    "flag": "🇳🇪",
    "states": [
      "Agadez",
      "Diffa",
      "Dosso",
      "Maradi",
      "Tahoua",
      "Tillabéri",
      "Zinder"
    ]
  },
  {
    "name": "Nigeria",
    "code": "NG",
    "dial_code": "+234",
    "flag": "🇳🇬",
    "states": [
      "Abia",
      "Abuja Federal Capital Territory",
      "Adamawa",
      "Akwa Ibom",
      "Anambra",
      "Bauchi",
      "Bayelsa",
      "Benue",
      "Borno",
      "Cross River",
      "Delta",
      "Ebonyi",
      "Edo",
      "Ekiti",
      "Enugu",
      "Gombe",
      "Imo",
      "Jigawa",
      "Kaduna",
      "Kano",
      "Katsina",
      "Kebbi",
      "Kogi",
      "Kwara",
      "Lagos",
      "Nasarawa",
      "Niger",
      "Ogun",
      "Ondo",
      "Osun",
      "Oyo",
      "Plateau",
      "Rivers",
      "Sokoto",
      "Taraba",
      "Yobe",
      "Zamfara"
    ]
  },
  {
    "name": "Niue",
    "code": "NU",
    "dial_code": "+683",
    "flag": "🇳🇺",
    "states": [
      "Alofi North",
      "Alofi South",
      "Avatele",
      "Hakupu",
      "Hikutavake",
      "Lakepa",
      "Liku",
      "Makefu",
      "Mutalau",
      "Namukulu",
      "Tamakautoga",
      "Toi",
      "Tuapa",
      "Vaiea"
    ]
  },
  {
    "name": "Norfolk Island",
    "code": "NF",
    "dial_code": "+672",
    "flag": "🇳🇫",
    "states": [
      "No states"
    ]
  },
  {
    "name": "North Korea",
    "code": "KP",
    "dial_code": "+850",
    "flag": "🇰🇵",
    "states": [
      "Chagang",
      "Kangwon",
      "North Hamgyong",
      "North Hwanghae",
      "North Pyongan",
      "Pyongyang",
      "Rason",
      "Ryanggang",
      "South Hamgyong",
      "South Hwanghae",
      "South Pyongan"
    ]
  },
  {
    "name": "North Macedonia",
    "code": "MK",
    "dial_code": "+389",
    "flag": "🇲🇰",
    "states": [
      "Aerodrom",
      "Aračinovo",
      "Berovo",
      "Bitola",
      "Bogdanci",
      "Bogovinje",
      "Bosilovo",
      "Brvenica",
      "Butel",
      "Čair",
      "Čaška",
      "Centar",
      "Centar Župa",
      "Češinovo-Obleševo",
      "Čučer-Sandevo",
      "Debarca",
      "Delčevo",
      "Demir Hisar",
      "Demir Kapija",
      "Dojran",
      "Dolneni",
      "Drugovo",
      "Gazi Baba",
      "Gevgelija",
      "Gjorče Petrov",
      "Gostivar",
      "Gradsko",
      "Greater Skopje",
      "Ilinden",
      "Jegunovce",
      "Karbinci",
      "Karpoš",
      "Kavadarci",
      "Kičevo",
      "Kisela Voda",
      "Kočani",
      "Konče",
      "Kratovo",
      "Kriva Palanka",
      "Krivogaštani",
      "Kruševo",
      "Kumanovo",
      "Lipkovo",
      "Lozovo",
      "Makedonska Kamenica",
      "Makedonski Brod",
      "Mavrovo and Rostuša",
      "Mogila",
      "Negotino",
      "Novaci",
      "Novo Selo",
      "Ohrid",
      "Oslomej ",
      "Pehčevo",
      "Petrovec",
      "Plasnica",
      "Prilep",
      "Probištip",
      "Radoviš",
      "Rankovce",
      "Resen",
      "Rosoman",
      "Saraj",
      "Sopište",
      "Staro Nagoričane",
      "Štip",
      "Struga",
      "Strumica",
      "Studeničani",
      "Šuto Orizari",
      "Sveti Nikole",
      "Tearce",
      "Tetovo",
      "Valandovo",
      "Vasilevo",
      "Veles",
      "Vevčani",
      "Vinica",
      "Vraneštica",
      "Vrapčište",
      "Zajas",
      "Zelenikovo",
      "Želino",
      "Zrnovci"
    ]
  },
  {
    "name": "Northern Mariana Islands",
    "code": "MP",
    "dial_code": "+1",
    "flag": "🇲🇵",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Norway",
    "code": "NO",
    "dial_code": "+47",
    "flag": "🇳🇴",
    "states": [
      "Agder",
      "Akershus",
      "Buskerud",
      "Finnmark",
      "Innlandet",
      "Jan Mayen",
      "Møre og Romsdal",
      "Nordland",
      "Oslo",
      "Østfold",
      "Rogaland",
      "Svalbard",
      "Telemark",
      "Troms",
      "Trøndelag",
      "Vestfold",
      "Vestland"
    ]
  },
  {
    "name": "Oman",
    "code": "OM",
    "dial_code": "+968",
    "flag": "🇴🇲",
    "states": [
      "Ad Dakhiliyah",
      "Ad Dhahirah",
      "Al Batinah North",
      "Al Batinah Region",
      "Al Batinah South",
      "Al Buraimi",
      "Al Wusta",
      "Ash Sharqiyah North",
      "Ash Sharqiyah Region",
      "Ash Sharqiyah South",
      "Dhofar",
      "Musandam",
      "Muscat"
    ]
  },
  {
    "name": "Pakistan",
    "code": "PK",
    "dial_code": "+92",
    "flag": "🇵🇰",
    "states": [
      "Azad Kashmir",
      "Balochistan",
      "Federally Administered Tribal Areas",
      "Gilgit-Baltistan",
      "Islamabad",
      "Khyber Pakhtunkhwa",
      "Punjab",
      "Sindh"
    ]
  },
  {
    "name": "Palau",
    "code": "PW",
    "dial_code": "+680",
    "flag": "🇵🇼",
    "states": [
      "Aimeliik",
      "Airai",
      "Angaur",
      "Hatohobei",
      "Kayangel",
      "Koror",
      "Melekeok",
      "Ngaraard",
      "Ngarchelong",
      "Ngardmau",
      "Ngatpang",
      "Ngchesar",
      "Ngeremlengui",
      "Ngiwal",
      "Peleliu",
      "Sonsorol"
    ]
  },
  {
    "name": "Palestinian Territory Occupied",
    "code": "PS",
    "dial_code": "+970",
    "flag": "🇵🇸",
    "states": [
      "Bethlehem",
      "Deir El Balah",
      "Gaza",
      "Hebron",
      "Jenin",
      "Jericho ",
      "Jerusalem (Quds)",
      "Khan Yunis",
      "Nablus",
      "North Gaza",
      "Qalqilya",
      "Rafah",
      "Ramallah",
      "Salfit",
      "Tubas",
      "Tulkarm"
    ]
  },
  {
    "name": "Panama",
    "code": "PA",
    "dial_code": "+507",
    "flag": "🇵🇦",
    "states": [
      "Bocas del Toro",
      "Chiriquí Province",
      "Coclé",
      "Colón",
      "Darién",
      "Emberá-Wounaan Comarca",
      "Guna",
      "Herrera",
      "Los Santos",
      "Ngöbe-Buglé Comarca",
      "Panamá",
      "Panamá Oeste",
      "Veraguas"
    ]
  },
  {
    "name": "Papua New Guinea",
    "code": "PG",
    "dial_code": "+675",
    "flag": "🇵🇬",
    "states": [
      "Bougainville",
      "Central",
      "Chimbu",
      "East New Britain",
      "East Sepik",
      "Eastern Highlands",
      "Enga",
      "Gulf",
      "Hela",
      "Jiwaka",
      "Madang",
      "Manus",
      "Milne Bay",
      "Morobe",
      "New Ireland",
      "Oro",
      "Port Moresby",
      "Sandaun",
      "Southern Highlands",
      "West New Britain",
      "Western",
      "Western Highlands"
    ]
  },
  {
    "name": "Paraguay",
    "code": "PY",
    "dial_code": "+595",
    "flag": "🇵🇾",
    "states": [
      "Alto Paraguay",
      "Alto Paraná",
      "Amambay",
      "Asuncion",
      "Boquerón",
      "Caaguazú",
      "Caazapá",
      "Canindeyú",
      "Central",
      "Concepción",
      "Cordillera",
      "Guairá",
      "Itapúa",
      "Misiones",
      "Ñeembucú",
      "Paraguarí",
      "Presidente Hayes",
      "San Pedro"
    ]
  },
  {
    "name": "Peru",
    "code": "PE",
    "dial_code": "+51",
    "flag": "🇵🇪",
    "states": [
      "Amazonas",
      "Áncash",
      "Apurímac",
      "Arequipa",
      "Ayacucho",
      "Cajamarca",
      "Callao",
      "Cusco",
      "Huancavelica",
      "Huanuco",
      "Ica",
      "Junín",
      "La Libertad",
      "Lambayeque",
      "Lima",
      "Loreto",
      "Madre de Dios",
      "Moquegua",
      "Pasco",
      "Piura",
      "Puno",
      "San Martín",
      "Tacna",
      "Tumbes",
      "Ucayali"
    ]
  },
  {
    "name": "Philippines",
    "code": "PH",
    "dial_code": "+63",
    "flag": "🇵🇭",
    "states": [
      "Abra",
      "Agusan del Norte",
      "Agusan del Sur",
      "Aklan",
      "Albay",
      "Antique",
      "Apayao",
      "Aurora",
      "Autonomous Region in Muslim Mindanao",
      "Basilan",
      "Bataan",
      "Batanes",
      "Batangas",
      "Benguet",
      "Bicol",
      "Biliran",
      "Bohol",
      "Bukidnon",
      "Bulacan",
      "Cagayan",
      "Cagayan Valley",
      "Calabarzon",
      "Camarines Norte",
      "Camarines Sur",
      "Camiguin",
      "Capiz",
      "Caraga",
      "Catanduanes",
      "Cavite",
      "Cebu",
      "Central Luzon",
      "Central Visayas",
      "Cordillera Administrative",
      "Cotabato",
      "Davao",
      "Davao de Oro",
      "Davao del Norte",
      "Davao del Sur",
      "Davao Occidental",
      "Davao Oriental",
      "Dinagat Islands",
      "Eastern Samar",
      "Eastern Visayas",
      "Guimaras",
      "Ifugao",
      "Ilocos",
      "Ilocos Norte",
      "Ilocos Sur",
      "Iloilo",
      "Isabela",
      "Kalinga",
      "La Union",
      "Laguna",
      "Lanao del Norte",
      "Lanao del Sur",
      "Leyte",
      "Maguindanao del Norte",
      "Maguindanao del Sur",
      "Marinduque",
      "Masbate",
      "Mimaropa",
      "Misamis Occidental",
      "Misamis Oriental",
      "Mountain Province",
      "National Capital Region (Metro Manila)",
      "Negros Occidental",
      "Negros Oriental",
      "Northern Mindanao",
      "Northern Samar",
      "Nueva Ecija",
      "Nueva Vizcaya",
      "Occidental Mindoro",
      "Oriental Mindoro",
      "Palawan",
      "Pampanga",
      "Pangasinan",
      "Quezon",
      "Quirino",
      "Rizal",
      "Romblon",
      "Sarangani",
      "Siquijor",
      "Soccsksargen",
      "Sorsogon",
      "South Cotabato",
      "Southern Leyte",
      "Sultan Kudarat",
      "Sulu",
      "Surigao del Norte",
      "Surigao del Sur",
      "Tarlac",
      "Tawi-Tawi",
      "Western Samar",
      "Western Visayas",
      "Zambales",
      "Zamboanga del Norte",
      "Zamboanga del Sur",
      "Zamboanga Peninsula",
      "Zamboanga Sibugay"
    ]
  },
  {
    "name": "Pitcairn Island",
    "code": "PN",
    "dial_code": "+870",
    "flag": "🇵🇳",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Poland",
    "code": "PL",
    "dial_code": "+48",
    "flag": "🇵🇱",
    "states": [
      "Greater Poland",
      "Holy Cross",
      "Kuyavia-Pomerania",
      "Lesser Poland",
      "Lower Silesia",
      "Lublin",
      "Lubusz",
      "Łódź",
      "Mazovia",
      "Podlaskie",
      "Pomerania",
      "Silesia",
      "Subcarpathia",
      "Upper Silesia",
      "Warmia-Masuria",
      "West Pomerania"
    ]
  },
  {
    "name": "Portugal",
    "code": "PT",
    "dial_code": "+351",
    "flag": "🇵🇹",
    "states": [
      "Açores",
      "Aveiro",
      "Beja",
      "Braga",
      "Bragança",
      "Castelo Branco",
      "Coimbra",
      "Évora",
      "Faro",
      "Guarda",
      "Leiria",
      "Lisbon",
      "Madeira",
      "Portalegre",
      "Porto",
      "Santarém",
      "Setúbal",
      "Viana do Castelo",
      "Vila Real",
      "Viseu"
    ]
  },
  {
    "name": "Puerto Rico",
    "code": "PR",
    "dial_code": "+1",
    "flag": "🇵🇷",
    "states": [
      "Adjuntas",
      "Aguada",
      "Aguadilla",
      "Aguas Buenas",
      "Aibonito",
      "Añasco",
      "Arecibo",
      "Arecibo",
      "Arroyo",
      "Barceloneta",
      "Barranquitas",
      "Bayamon",
      "Bayamón",
      "Cabo Rojo",
      "Caguas",
      "Caguas",
      "Camuy",
      "Canóvanas",
      "Carolina",
      "Carolina",
      "Cataño",
      "Cayey",
      "Ceiba",
      "Ciales",
      "Cidra",
      "Coamo",
      "Comerío",
      "Corozal",
      "Culebra",
      "Dorado",
      "Fajardo",
      "Florida",
      "Guánica",
      "Guayama",
      "Guayanilla",
      "Guaynabo",
      "Guaynabo",
      "Gurabo",
      "Hatillo",
      "Hormigueros",
      "Humacao",
      "Isabela",
      "Jayuya",
      "Juana Díaz",
      "Juncos",
      "Lajas",
      "Lares",
      "Las Marías",
      "Las Piedras",
      "Loíza",
      "Luquillo",
      "Manatí",
      "Maricao",
      "Maunabo",
      "Mayagüez",
      "Mayagüez",
      "Moca",
      "Morovis",
      "Naguabo",
      "Naranjito",
      "Orocovis",
      "Patillas",
      "Peñuelas",
      "Ponce",
      "Ponce",
      "Quebradillas",
      "Rincón",
      "Río Grande",
      "Sabana Grande",
      "Salinas",
      "San Germán",
      "San Juan",
      "San Juan",
      "San Lorenzo",
      "San Sebastián",
      "Santa Isabel",
      "Toa Alta",
      "Toa Baja",
      "Toa Baja",
      "Trujillo Alto",
      "Trujillo Alto",
      "Utuado",
      "Vega Alta",
      "Vega Baja",
      "Vieques",
      "Villalba",
      "Yabucoa",
      "Yauco"
    ]
  },
  {
    "name": "Qatar",
    "code": "QA",
    "dial_code": "+974",
    "flag": "🇶🇦",
    "states": [
      "Al Daayen",
      "Al Khor",
      "Al Rayyan",
      "Al Wakrah",
      "Al-Shahaniya",
      "Doha",
      "Madinat ash Shamal",
      "Umm Salal"
    ]
  },
  {
    "name": "Reunion",
    "code": "RE",
    "dial_code": "+262",
    "flag": "🇷🇪",
    "states": [
      "Saint-Benoît",
      "Saint-Denis",
      "Saint-Paul",
      "Saint-Pierre"
    ]
  },
  {
    "name": "Romania",
    "code": "RO",
    "dial_code": "+40",
    "flag": "🇷🇴",
    "states": [
      "Alba",
      "Arad",
      "Arges",
      "Bacău",
      "Bihor",
      "Bistrița-Năsăud",
      "Botoșani",
      "Braila",
      "Brașov",
      "Bucharest",
      "Buzău",
      "Călărași",
      "Caraș-Severin",
      "Cluj",
      "Constanța",
      "Covasna",
      "Dâmbovița",
      "Dolj",
      "Galați",
      "Giurgiu",
      "Gorj",
      "Harghita",
      "Hunedoara",
      "Ialomița",
      "Iași",
      "Ilfov",
      "Maramureș",
      "Mehedinți",
      "Mureș",
      "Neamț",
      "Olt",
      "Prahova",
      "Sălaj",
      "Satu Mare",
      "Sibiu",
      "Suceava",
      "Teleorman",
      "Timiș",
      "Tulcea",
      "Vâlcea",
      "Vaslui",
      "Vrancea"
    ]
  },
  {
    "name": "Russia",
    "code": "RU",
    "dial_code": "+7",
    "flag": "🇷🇺",
    "states": [
      "Adygea",
      "Altai",
      "Altai",
      "Amur",
      "Arkhangelsk",
      "Astrakhan",
      "Bashkortostan",
      "Belgorod",
      "Bryansk",
      "Buryatia",
      "Chechen",
      "Chelyabinsk",
      "Chukotka",
      "Chuvash",
      "Dagestan",
      "Ingushetia",
      "Irkutsk",
      "Ivanovo",
      "Jewish",
      "Kabardino-Balkar",
      "Kaliningrad",
      "Kalmykia",
      "Kaluga",
      "Kamchatka",
      "Karachay-Cherkess",
      "Karelia",
      "Kemerovo",
      "Khabarovsk",
      "Khakassia",
      "Khanty-Mansi",
      "Kirov",
      "Komi",
      "Kostroma",
      "Krasnodar",
      "Krasnoyarsk",
      "Kurgan",
      "Kursk",
      "Leningrad",
      "Lipetsk",
      "Magadan",
      "Mari El",
      "Mordovia",
      "Moscow",
      "Moscow",
      "Murmansk",
      "Nenets",
      "Nizhny Novgorod",
      "North Ossetia-Alania",
      "Novgorod",
      "Novosibirsk",
      "Omsk",
      "Orenburg",
      "Oryol",
      "Penza",
      "Perm",
      "Primorsky",
      "Pskov",
      "Rostov",
      "Ryazan",
      "Saint Petersburg",
      "Sakha",
      "Sakhalin",
      "Samara",
      "Saratov",
      "Smolensk",
      "Stavropol",
      "Sverdlovsk",
      "Tambov",
      "Tatarstan",
      "Tomsk",
      "Tula",
      "Tuva",
      "Tver",
      "Tyumen",
      "Udmurt",
      "Ulyanovsk",
      "Vladimir",
      "Volgograd Oblast",
      "Vologda",
      "Voronezh",
      "Yamalo-Nenets",
      "Yaroslavl",
      "Zabaykalsky"
    ]
  },
  {
    "name": "Rwanda",
    "code": "RW",
    "dial_code": "+250",
    "flag": "🇷🇼",
    "states": [
      "Eastern",
      "Kigali",
      "Northern",
      "Southern",
      "Western"
    ]
  },
  {
    "name": "Saint Helena",
    "code": "SH",
    "dial_code": "+290",
    "flag": "🇸🇭",
    "states": [
      "Alarm Forest",
      "Blue Hill",
      "Half Tree Hollow",
      "Jamestown",
      "Levelwood",
      "Longwood",
      "Saint Paul's",
      "Sandy Bay"
    ]
  },
  {
    "name": "Saint Kitts and Nevis",
    "code": "KN",
    "dial_code": "+1",
    "flag": "🇰🇳",
    "states": [
      "Christ Church Nichola Town",
      "Nevis",
      "Saint Anne Sandy Point",
      "Saint George Basseterre",
      "Saint George Gingerland",
      "Saint James Windward",
      "Saint John Capisterre",
      "Saint John Figtree",
      "Saint Kitts",
      "Saint Mary Cayon",
      "Saint Paul Capisterre",
      "Saint Paul Charlestown",
      "Saint Peter Basseterre",
      "Saint Thomas Lowland",
      "Saint Thomas Middle Island",
      "Trinity Palmetto Point"
    ]
  },
  {
    "name": "Saint Lucia",
    "code": "LC",
    "dial_code": "+1",
    "flag": "🇱🇨",
    "states": [
      "Anse la Raye",
      "Canaries",
      "Castries",
      "Choiseul",
      "Dauphin",
      "Dennery",
      "Gros Islet",
      "Laborie",
      "Micoud",
      "Praslin",
      "Soufrière",
      "Vieux Fort"
    ]
  },
  {
    "name": "Saint Pierre and Miquelon",
    "code": "PM",
    "dial_code": "+508",
    "flag": "🇵🇲",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "code": "VC",
    "dial_code": "+1",
    "flag": "🇻🇨",
    "states": [
      "Charlotte",
      "Grenadines",
      "Saint Andrew",
      "Saint David",
      "Saint George",
      "Saint Patrick"
    ]
  },
  {
    "name": "Saint-Barthelemy",
    "code": "BL",
    "dial_code": "+590",
    "flag": "🇧🇱",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Saint-Martin (French part)",
    "code": "MF",
    "dial_code": "+590",
    "flag": "🇲🇫",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Samoa",
    "code": "WS",
    "dial_code": "+685",
    "flag": "🇼🇸",
    "states": [
      "A'ana",
      "Aiga-i-le-Tai",
      "Atua",
      "Fa'asaleleaga",
      "Gaga'emauga",
      "Gaga'ifomauga",
      "Palauli",
      "Satupa'itea",
      "Tuamasaga",
      "Va'a-o-Fonoti",
      "Vaisigano"
    ]
  },
  {
    "name": "San Marino",
    "code": "SM",
    "dial_code": "+378",
    "flag": "🇸🇲",
    "states": [
      "Acquaviva",
      "Borgo Maggiore",
      "Chiesanuova",
      "Domagnano",
      "Faetano",
      "Fiorentino",
      "Montegiardino",
      "San Marino",
      "Serravalle"
    ]
  },
  {
    "name": "Sao Tome and Principe",
    "code": "ST",
    "dial_code": "+239",
    "flag": "🇸🇹",
    "states": [
      "Príncipe",
      "São Tomé"
    ]
  },
  {
    "name": "Saudi Arabia",
    "code": "SA",
    "dial_code": "+966",
    "flag": "🇸🇦",
    "states": [
      "'Asir",
      "Al Bahah",
      "Al Jawf",
      "Al Madinah",
      "Al-Qassim",
      "Eastern Province",
      "Ha'il",
      "Jizan",
      "Makkah",
      "Najran",
      "Northern Borders",
      "Riyadh",
      "Tabuk"
    ]
  },
  {
    "name": "Senegal",
    "code": "SN",
    "dial_code": "+221",
    "flag": "🇸🇳",
    "states": [
      "Dakar",
      "Diourbel Region",
      "Fatick",
      "Kaffrine",
      "Kaolack",
      "Kédougou",
      "Kolda",
      "Louga",
      "Matam",
      "Saint-Louis",
      "Sédhiou",
      "Tambacounda Region",
      "Thiès Region",
      "Ziguinchor"
    ]
  },
  {
    "name": "Serbia",
    "code": "RS",
    "dial_code": "+381",
    "flag": "🇷🇸",
    "states": [
      "Belgrade",
      "Bor",
      "Braničevo",
      "Central Banat",
      "Jablanica",
      "Kolubara",
      "Mačva",
      "Moravica",
      "Nišava",
      "North Bačka",
      "North Banat",
      "Pčinja",
      "Pirot",
      "Podunavlje",
      "Pomoravlje",
      "Rasina",
      "Raška",
      "South Bačka",
      "South Banat",
      "Srem",
      "Šumadija",
      "Toplica",
      "Vojvodina",
      "West Bačka",
      "Zaječar",
      "Zlatibor"
    ]
  },
  {
    "name": "Seychelles",
    "code": "SC",
    "dial_code": "+248",
    "flag": "🇸🇨",
    "states": [
      "Anse Boileau",
      "Anse Royale",
      "Anse-aux-Pins",
      "Au Cap",
      "Baie Lazare",
      "Baie Sainte Anne",
      "Beau Vallon",
      "Bel Air",
      "Bel Ombre",
      "Cascade",
      "Glacis",
      "Grand'Anse Mahé",
      "Grand'Anse Praslin",
      "La Digue",
      "La Rivière Anglaise",
      "Les Mamelles",
      "Mont Buxton",
      "Mont Fleuri",
      "Plaisance",
      "Pointe La Rue",
      "Port Glaud",
      "Roche Caiman",
      "Saint Louis",
      "Takamaka"
    ]
  },
  {
    "name": "Sierra Leone",
    "code": "SL",
    "dial_code": "+232",
    "flag": "🇸🇱",
    "states": [
      "Eastern",
      "Northern",
      "Southern",
      "Western"
    ]
  },
  {
    "name": "Singapore",
    "code": "SG",
    "dial_code": "+65",
    "flag": "🇸🇬",
    "states": [
      "Central Singapore",
      "North East",
      "North West",
      "South East",
      "South West"
    ]
  },
  {
    "name": "Sint Maarten (Dutch part)",
    "code": "SX",
    "dial_code": "+1721",
    "flag": "🇸🇽",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Slovakia",
    "code": "SK",
    "dial_code": "+421",
    "flag": "🇸🇰",
    "states": [
      "Banská Bystrica",
      "Bratislava",
      "Košice",
      "Nitra",
      "Prešov",
      "Trenčín",
      "Trnava",
      "Žilina"
    ]
  },
  {
    "name": "Slovenia",
    "code": "SI",
    "dial_code": "+386",
    "flag": "🇸🇮",
    "states": [
      "Ajdovščina",
      "Ankaran",
      "Apače",
      "Beltinci",
      "Benedikt",
      "Bistrica ob Sotli",
      "Bled",
      "Bloke",
      "Bohinj",
      "Borovnica",
      "Bovec",
      "Braslovče",
      "Brda",
      "Brežice",
      "Brezovica",
      "Cankova",
      "Celje",
      "Cerklje na Gorenjskem",
      "Cerknica",
      "Cerkno",
      "Cerkvenjak",
      "Cirkulane",
      "Črenšovci",
      "Črna na Koroškem",
      "Črnomelj",
      "Destrnik",
      "Divača",
      "Dobje",
      "Dobrepolje",
      "Dobrna",
      "Dobrova–Polhov Gradec",
      "Dobrovnik",
      "Dol pri Ljubljani",
      "Dolenjske Toplice",
      "Domžale",
      "Dornava",
      "Dravograd",
      "Duplek",
      "Gorenja Vas–Poljane",
      "Gorišnica",
      "Gorje",
      "Gornja Radgona",
      "Gornji Grad",
      "Gornji Petrovci",
      "Grad",
      "Grosuplje",
      "Hajdina",
      "Hoče–Slivnica",
      "Hodoš",
      "Horjul",
      "Hrastnik",
      "Hrpelje–Kozina",
      "Idrija",
      "Ig",
      "Ilirska Bistrica",
      "Ivančna Gorica",
      "Izola",
      "Jesenice",
      "Jezersko",
      "Juršinci",
      "Kamnik",
      "Kanal ob Soči",
      "Kidričevo",
      "Kobarid",
      "Kobilje",
      "Kočevje",
      "Komen",
      "Komenda",
      "Koper",
      "Kostanjevica na Krki",
      "Kostel",
      "Kozje",
      "Kranj",
      "Kranjska Gora",
      "Križevci",
      "Krško",
      "Kungota",
      "Kuzma",
      "Laško",
      "Lenart",
      "Lendava",
      "Litija",
      "Ljubljana",
      "Ljubno",
      "Ljutomer",
      "Log–Dragomer",
      "Logatec",
      "Loška Dolina",
      "Loški Potok",
      "Lovrenc na Pohorju",
      "Luče",
      "Lukovica",
      "Majšperk",
      "Makole",
      "Maribor",
      "Markovci",
      "Medvode",
      "Mengeš",
      "Metlika",
      "Mežica",
      "Miklavž na Dravskem Polju",
      "Miren–Kostanjevica",
      "Mirna",
      "Mirna Peč",
      "Mislinja",
      "Mokronog–Trebelno",
      "Moravče",
      "Moravske Toplice",
      "Mozirje",
      "Murska Sobota",
      "Muta",
      "Naklo",
      "Nazarje",
      "Nova Gorica",
      "Novo Mesto",
      "Odranci",
      "Oplotnica",
      "Ormož",
      "Osilnica",
      "Pesnica",
      "Piran",
      "Pivka",
      "Podčetrtek",
      "Podlehnik",
      "Podvelka",
      "Poljčane",
      "Polzela",
      "Postojna",
      "Prebold",
      "Preddvor",
      "Prevalje",
      "Ptuj",
      "Puconci",
      "Rače–Fram",
      "Radeče",
      "Radenci",
      "Radlje ob Dravi",
      "Radovljica",
      "Ravne na Koroškem",
      "Razkrižje",
      "Rečica ob Savinji",
      "Renče–Vogrsko",
      "Ribnica",
      "Ribnica na Pohorju",
      "Rogaška Slatina",
      "Rogašovci",
      "Rogatec",
      "Ruše",
      "Šalovci",
      "Selnica ob Dravi",
      "Semič",
      "Šempeter–Vrtojba",
      "Šenčur",
      "Šentilj",
      "Šentjernej",
      "Šentjur",
      "Šentrupert",
      "Sevnica",
      "Sežana",
      "Škocjan",
      "Škofja Loka",
      "Škofljica",
      "Slovenj Gradec",
      "Slovenska Bistrica",
      "Slovenske Konjice",
      "Šmarje pri Jelšah",
      "Šmarješke Toplice",
      "Šmartno ob Paki",
      "Šmartno pri Litiji",
      "Sodražica",
      "Solčava",
      "Šoštanj",
      "Središče ob Dravi",
      "Starše",
      "Štore",
      "Straža",
      "Sveta Ana",
      "Sveta Trojica v Slovenskih Goricah",
      "Sveti Andraž v Slovenskih Goricah",
      "Sveti Jurij ob Ščavnici",
      "Sveti Jurij v Slovenskih Goricah",
      "Sveti Tomaž",
      "Tabor",
      "Tišina",
      "Tolmin",
      "Trbovlje",
      "Trebnje",
      "Trnovska Vas",
      "Tržič",
      "Trzin",
      "Turnišče",
      "Velika Polana",
      "Velike Lašče",
      "Veržej",
      "Videm",
      "Vipava",
      "Vitanje",
      "Vodice",
      "Vojnik",
      "Vransko",
      "Vrhnika",
      "Vuzenica",
      "Zagorje ob Savi",
      "Žalec",
      "Zavrč",
      "Železniki",
      "Žetale",
      "Žiri",
      "Žirovnica",
      "Zreče",
      "Žužemberk"
    ]
  },
  {
    "name": "Solomon Islands",
    "code": "SB",
    "dial_code": "+677",
    "flag": "🇸🇧",
    "states": [
      "Central",
      "Choiseul",
      "Guadalcanal",
      "Honiara",
      "Isabel",
      "Makira-Ulawa",
      "Malaita",
      "Rennell and Bellona",
      "Temotu",
      "Western"
    ]
  },
  {
    "name": "Somalia",
    "code": "SO",
    "dial_code": "+252",
    "flag": "🇸🇴",
    "states": [
      "Awdal",
      "Bakool",
      "Banaadir",
      "Bari",
      "Bay",
      "Galguduud",
      "Gedo",
      "Hiran",
      "Lower Juba",
      "Lower Shebelle",
      "Middle Juba",
      "Middle Shebelle",
      "Mudug",
      "Nugal",
      "Sanaag",
      "Togdheer"
    ]
  },
  {
    "name": "South Africa",
    "code": "ZA",
    "dial_code": "+27",
    "flag": "🇿🇦",
    "states": [
      "Eastern Cape",
      "Free State",
      "Gauteng",
      "KwaZulu-Natal",
      "Limpopo",
      "Mpumalanga",
      "North West",
      "Northern Cape",
      "Western Cape"
    ]
  },
  {
    "name": "South Georgia",
    "code": "GS",
    "dial_code": "+500",
    "flag": "🇬🇸",
    "states": [
      "No states"
    ]
  },
  {
    "name": "South Korea",
    "code": "KR",
    "dial_code": "+82",
    "flag": "🇰🇷",
    "states": [
      "Busan",
      "Daegu",
      "Daejeon",
      "Gangwon",
      "Gwangju",
      "Gyeonggi",
      "Incheon",
      "Jeju",
      "North Chungcheong",
      "North Gyeongsang",
      "North Jeolla",
      "Sejong City",
      "Seoul",
      "South Chungcheong",
      "South Gyeongsang",
      "South Jeolla",
      "Ulsan"
    ]
  },
  {
    "name": "South Sudan",
    "code": "SS",
    "dial_code": "+211",
    "flag": "🇸🇸",
    "states": [
      "Central Equatoria",
      "Eastern Equatoria",
      "Jonglei State",
      "Lakes",
      "Northern Bahr el Ghazal",
      "Unity",
      "Upper Nile",
      "Warrap",
      "Western Bahr el Ghazal",
      "Western Equatoria"
    ]
  },
  {
    "name": "Spain",
    "code": "ES",
    "dial_code": "+34",
    "flag": "🇪🇸",
    "states": [
      "A Coruña",
      "Albacete",
      "Alicante",
      "Almeria",
      "Andalusia",
      "Araba",
      "Aragon",
      "Asturias",
      "Asturias",
      "Ávila",
      "Badajoz",
      "Balearic Islands",
      "Barcelona",
      "Basque Country",
      "Bizkaia",
      "Burgos",
      "Caceres",
      "Cádiz",
      "Canary Islands",
      "Cantabria",
      "Cantabria",
      "Castellón",
      "Castile and Leon",
      "Castilla-La Mancha",
      "Catalonia",
      "Ceuta",
      "Ciudad Real",
      "Community of Madrid",
      "Córdoba",
      "Cuenca",
      "Estremadura",
      "Galicia",
      "Gipuzkoa",
      "Girona",
      "Granada",
      "Guadalajara",
      "Huelva",
      "Huesca",
      "Islas Baleares",
      "Jaén",
      "La Rioja",
      "La Rioja",
      "Las Palmas",
      "León",
      "Lleida",
      "Lugo",
      "Madrid",
      "Málaga",
      "Melilla",
      "Murcia",
      "Navarra",
      "Navarre",
      "Ourense",
      "Palencia",
      "Pontevedra",
      "Region of Murcia",
      "Salamanca",
      "Santa Cruz de Tenerife",
      "Segovia",
      "Sevilla",
      "Soria",
      "Tarragona",
      "Teruel",
      "Toledo",
      "Valencia",
      "Valencian Community",
      "Valladolid",
      "Zamora",
      "Zaragoza"
    ]
  },
  {
    "name": "Sri Lanka",
    "code": "LK",
    "dial_code": "+94",
    "flag": "🇱🇰",
    "states": [
      "Ampara",
      "Anuradhapura",
      "Badulla",
      "Batticaloa",
      "Central",
      "Colombo",
      "Eastern",
      "Galle",
      "Gampaha",
      "Hambantota",
      "Jaffna",
      "Kalutara",
      "Kandy",
      "Kegalle",
      "Kilinochchi",
      "Kurunegala",
      "Mannar",
      "Matale",
      "Matara",
      "Monaragala",
      "Mullaitivu",
      "North Central",
      "North Western",
      "Northern",
      "Nuwara Eliya",
      "Polonnaruwa",
      "Puttalam",
      "Ratnapura",
      "Sabaragamuwa",
      "Southern",
      "Trincomalee",
      "Uva",
      "Vavuniya",
      "Western"
    ]
  },
  {
    "name": "Sudan",
    "code": "SD",
    "dial_code": "+249",
    "flag": "🇸🇩",
    "states": [
      "Al Jazirah",
      "Al Qadarif",
      "Blue Nile",
      "Central Darfur",
      "East Darfur",
      "Kassala",
      "Khartoum",
      "North Darfur",
      "North Kordofan",
      "Northern",
      "Red Sea",
      "River Nile",
      "Sennar",
      "South Darfur",
      "South Kordofan",
      "West Darfur",
      "West Kordofan",
      "White Nile"
    ]
  },
  {
    "name": "Suriname",
    "code": "SR",
    "dial_code": "+597",
    "flag": "🇸🇷",
    "states": [
      "Brokopondo",
      "Commewijne",
      "Coronie",
      "Marowijne",
      "Nickerie",
      "Para",
      "Paramaribo",
      "Saramacca",
      "Sipaliwini",
      "Wanica"
    ]
  },
  {
    "name": "Svalbard and Jan Mayen Islands",
    "code": "SJ",
    "dial_code": "+47",
    "flag": "🇸🇯",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Sweden",
    "code": "SE",
    "dial_code": "+46",
    "flag": "🇸🇪",
    "states": [
      "Blekinge",
      "Dalarna",
      "Gävleborg",
      "Gotland",
      "Halland",
      "Jämtland",
      "Jönköping",
      "Kalmar",
      "Kronoberg",
      "Norrbotten",
      "Örebro",
      "Östergötland",
      "Skåne",
      "Södermanland",
      "Stockholm",
      "Uppsala",
      "Värmland",
      "Västerbotten",
      "Västernorrland",
      "Västmanland",
      "Västra Götaland"
    ]
  },
  {
    "name": "Switzerland",
    "code": "CH",
    "dial_code": "+41",
    "flag": "🇨🇭",
    "states": [
      "Aargau",
      "Appenzell Ausserrhoden",
      "Appenzell Innerrhoden",
      "Basel-Land",
      "Basel-Stadt",
      "Bern",
      "Fribourg",
      "Geneva",
      "Glarus",
      "Graubünden",
      "Jura",
      "Lucerne",
      "Neuchâtel",
      "Nidwalden",
      "Obwalden",
      "Schaffhausen",
      "Schwyz",
      "Solothurn",
      "St. Gallen",
      "Thurgau",
      "Ticino",
      "Uri",
      "Valais",
      "Vaud",
      "Zug",
      "Zürich"
    ]
  },
  {
    "name": "Syria",
    "code": "SY",
    "dial_code": "+963",
    "flag": "🇸🇾",
    "states": [
      "Al-Hasakah",
      "Al-Raqqah",
      "Aleppo",
      "As-Suwayda",
      "Damascus",
      "Daraa",
      "Deir ez-Zor",
      "Hama",
      "Homs",
      "Idlib",
      "Latakia",
      "Quneitra",
      "Rif Dimashq",
      "Tartus"
    ]
  },
  {
    "name": "Taiwan",
    "code": "TW",
    "dial_code": "+886",
    "flag": "🇹🇼",
    "states": [
      "Changhua",
      "Chiayi",
      "Chiayi",
      "Hsinchu",
      "Hsinchu",
      "Hualien",
      "Kaohsiung",
      "Keelung",
      "Kinmen",
      "Lienchiang",
      "Miaoli",
      "Nantou",
      "New Taipei",
      "Penghu",
      "Pingtung",
      "Taichung",
      "Tainan",
      "Taipei",
      "Taitung",
      "Taoyuan",
      "Yilan",
      "Yunlin"
    ]
  },
  {
    "name": "Tajikistan",
    "code": "TJ",
    "dial_code": "+992",
    "flag": "🇹🇯",
    "states": [
      "Gorno-Badakhshan",
      "Khatlon",
      "Nohiyahoi Tobei Jumhurí ",
      "Sughd "
    ]
  },
  {
    "name": "Tanzania",
    "code": "TZ",
    "dial_code": "+255",
    "flag": "🇹🇿",
    "states": [
      "Arusha",
      "Dar es Salaam",
      "Dodoma",
      "Geita",
      "Iringa",
      "Kagera",
      "Katavi",
      "Kigoma",
      "Kilimanjaro",
      "Lindi",
      "Manyara",
      "Mara",
      "Mbeya",
      "Morogoro",
      "Mtwara",
      "Mwanza",
      "Njombe",
      "Pemba North",
      "Pemba South",
      "Pwani",
      "Rukwa",
      "Ruvuma",
      "Shinyanga",
      "Simiyu",
      "Singida",
      "Songwe",
      "Tabora",
      "Tanga",
      "Zanzibar North",
      "Zanzibar South",
      "Zanzibar West"
    ]
  },
  {
    "name": "Thailand",
    "code": "TH",
    "dial_code": "+66",
    "flag": "🇹🇭",
    "states": [
      "Amnat Charoen",
      "Ang Thong",
      "Bangkok",
      "Bueng Kan",
      "Buri Ram",
      "Chachoengsao",
      "Chai Nat",
      "Chaiyaphum",
      "Chanthaburi",
      "Chiang Mai",
      "Chiang Rai",
      "Chon Buri",
      "Chumphon",
      "Kalasin",
      "Kamphaeng Phet",
      "Kanchanaburi",
      "Khon Kaen",
      "Krabi",
      "Lampang",
      "Lamphun",
      "Loei",
      "Lop Buri",
      "Mae Hong Son",
      "Maha Sarakham",
      "Mukdahan",
      "Nakhon Nayok",
      "Nakhon Pathom",
      "Nakhon Phanom",
      "Nakhon Ratchasima",
      "Nakhon Sawan",
      "Nakhon Si Thammarat",
      "Nan",
      "Narathiwat",
      "Nong Bua Lam Phu",
      "Nong Khai",
      "Nonthaburi",
      "Pathum Thani",
      "Pattani",
      "Pattaya",
      "Phangnga",
      "Phatthalung",
      "Phayao",
      "Phetchabun",
      "Phetchaburi",
      "Phichit",
      "Phitsanulok",
      "Phra Nakhon Si Ayutthaya",
      "Phrae",
      "Phuket",
      "Prachin Buri",
      "Prachuap Khiri Khan",
      "Ranong",
      "Ratchaburi",
      "Rayong",
      "Roi Et",
      "Sa Kaeo",
      "Sakon Nakhon",
      "Samut Prakan",
      "Samut Sakhon",
      "Samut Songkhram",
      "Saraburi",
      "Satun",
      "Si Sa Ket",
      "Sing Buri",
      "Songkhla",
      "Sukhothai",
      "Suphan Buri",
      "Surat Thani",
      "Surin",
      "Tak",
      "Trang",
      "Trat",
      "Ubon Ratchathani",
      "Udon Thani",
      "Uthai Thani",
      "Uttaradit",
      "Yala",
      "Yasothon"
    ]
  },
  {
    "name": "The Bahamas",
    "code": "BS",
    "dial_code": "+1",
    "flag": "🇧🇸",
    "states": [
      "Acklins",
      "Acklins and Crooked Islands",
      "Berry Islands",
      "Bimini",
      "Black Point",
      "Cat Island",
      "Central Abaco",
      "Central Andros",
      "Central Eleuthera",
      "Crooked Island",
      "East Grand Bahama",
      "Exuma",
      "Freeport",
      "Fresh Creek",
      "Governor's Harbour",
      "Grand Cay",
      "Green Turtle Cay",
      "Harbour Island",
      "High Rock",
      "Hope Town",
      "Inagua",
      "Kemps Bay",
      "Long Island",
      "Mangrove Cay",
      "Marsh Harbour",
      "Mayaguana",
      "New Providence",
      "Nichollstown and Berry Islands",
      "North Abaco",
      "North Andros",
      "North Eleuthera",
      "Ragged Island",
      "Rock Sound",
      "Rum Cay",
      "San Salvador and Rum Cay",
      "San Salvador Island",
      "Sandy Point",
      "South Abaco",
      "South Andros",
      "South Eleuthera",
      "Spanish Wells",
      "West Grand Bahama"
    ]
  },
  {
    "name": "The Gambia ",
    "code": "GM",
    "dial_code": "+220",
    "flag": "🇬🇲",
    "states": [
      "Banjul",
      "Central River",
      "Lower River",
      "North Bank",
      "Upper River",
      "West Coast"
    ]
  },
  {
    "name": "Timor-Leste",
    "code": "TL",
    "dial_code": "+670",
    "flag": "🇹🇱",
    "states": [
      "Aileu",
      "Ainaro",
      "Baucau",
      "Bobonaro",
      "Cova Lima",
      "Dili",
      "Ermera",
      "Lautém",
      "Liquiçá",
      "Manatuto",
      "Manufahi",
      "Viqueque"
    ]
  },
  {
    "name": "Togo",
    "code": "TG",
    "dial_code": "+228",
    "flag": "🇹🇬",
    "states": [
      "Centrale",
      "Kara",
      "Maritime",
      "Plateaux",
      "Savanes"
    ]
  },
  {
    "name": "Tokelau",
    "code": "TK",
    "dial_code": "+690",
    "flag": "🇹🇰",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Tonga",
    "code": "TO",
    "dial_code": "+676",
    "flag": "🇹🇴",
    "states": [
      "Haʻapai",
      "ʻEua",
      "Niuas",
      "Tongatapu",
      "Vavaʻu"
    ]
  },
  {
    "name": "Trinidad and Tobago",
    "code": "TT",
    "dial_code": "+1",
    "flag": "🇹🇹",
    "states": [
      "Arima",
      "Chaguanas",
      "Couva-Tabaquite-Talparo",
      "Diego Martin",
      "Eastern Tobago",
      "Penal-Debe",
      "Point Fortin",
      "Port of Spain",
      "Princes Town",
      "Rio Claro-Mayaro",
      "San Fernando",
      "San Juan-Laventille",
      "Sangre Grande",
      "Siparia",
      "Tunapuna-Piarco",
      "Western Tobago"
    ]
  },
  {
    "name": "Tunisia",
    "code": "TN",
    "dial_code": "+216",
    "flag": "🇹🇳",
    "states": [
      "Ariana",
      "Béja",
      "Ben Arous",
      "Bizerte",
      "Gabès",
      "Gafsa",
      "Jendouba",
      "Kairouan",
      "Kasserine",
      "Kebili",
      "Kef",
      "Mahdia",
      "Manouba",
      "Medenine",
      "Monastir",
      "Nabeul",
      "Sfax",
      "Sidi Bouzid",
      "Siliana",
      "Sousse",
      "Tataouine",
      "Tozeur",
      "Tunis",
      "Zaghouan"
    ]
  },
  {
    "name": "Turkey",
    "code": "TR",
    "dial_code": "+90",
    "flag": "🇹🇷",
    "states": [
      "Adana",
      "Adıyaman",
      "Afyonkarahisar",
      "Ağrı",
      "Aksaray",
      "Amasya",
      "Ankara",
      "Antalya",
      "Ardahan",
      "Artvin",
      "Aydın",
      "Balıkesir",
      "Bartın",
      "Batman",
      "Bayburt",
      "Bilecik",
      "Bingöl",
      "Bitlis",
      "Bolu",
      "Burdur",
      "Bursa",
      "Çanakkale",
      "Çankırı",
      "Çorum",
      "Denizli",
      "Diyarbakır",
      "Düzce",
      "Edirne",
      "Elazığ",
      "Erzincan",
      "Erzurum",
      "Eskişehir",
      "Gaziantep",
      "Giresun",
      "Gümüşhane",
      "Hakkâri",
      "Hatay",
      "Iğdır",
      "Isparta",
      "İstanbul",
      "İzmir",
      "Kahramanmaraş",
      "Karabük",
      "Karaman",
      "Kars",
      "Kastamonu",
      "Kayseri",
      "Kilis",
      "Kırıkkale",
      "Kırklareli",
      "Kırşehir",
      "Kocaeli",
      "Konya",
      "Kütahya",
      "Malatya",
      "Manisa",
      "Mardin",
      "Mersin",
      "Muğla",
      "Muş",
      "Nevşehir",
      "Niğde",
      "Ordu",
      "Osmaniye",
      "Rize",
      "Sakarya",
      "Samsun",
      "Şanlıurfa",
      "Siirt",
      "Sinop",
      "Sivas",
      "Şırnak",
      "Tekirdağ",
      "Tokat",
      "Trabzon",
      "Tunceli",
      "Uşak",
      "Van",
      "Yalova",
      "Yozgat",
      "Zonguldak"
    ]
  },
  {
    "name": "Turkmenistan",
    "code": "TM",
    "dial_code": "+993",
    "flag": "🇹🇲",
    "states": [
      "Ahal",
      "Ashgabat",
      "Balkan",
      "Daşoguz",
      "Lebap",
      "Mary"
    ]
  },
  {
    "name": "Turks and Caicos Islands",
    "code": "TC",
    "dial_code": "+1",
    "flag": "🇹🇨",
    "states": [
      "Grand Turk",
      "Middle Caicos",
      "North Caicos",
      "Providenciales",
      "Salt Cay",
      "South Caicos"
    ]
  },
  {
    "name": "Tuvalu",
    "code": "TV",
    "dial_code": "+688",
    "flag": "🇹🇻",
    "states": [
      "Funafuti",
      "Nanumanga",
      "Nanumea",
      "Niutao Island Council",
      "Nui",
      "Nukufetau",
      "Nukulaelae",
      "Vaitupu"
    ]
  },
  {
    "name": "Uganda",
    "code": "UG",
    "dial_code": "+256",
    "flag": "🇺🇬",
    "states": [
      "Abim",
      "Adjumani",
      "Agago",
      "Alebtong",
      "Amolatar",
      "Amudat",
      "Amuria",
      "Amuru",
      "Apac",
      "Arua",
      "Budaka",
      "Bududa",
      "Bugiri",
      "Bugweri",
      "Buhweju",
      "Buikwe",
      "Bukedea",
      "Bukomansimbi",
      "Bukwo",
      "Bulambuli",
      "Buliisa",
      "Bundibugyo",
      "Bunyangabu",
      "Bushenyi",
      "Busia",
      "Butaleja",
      "Butambala",
      "Butebo",
      "Buvuma",
      "Buyende",
      "Central",
      "Dokolo",
      "Eastern",
      "Gomba",
      "Gulu",
      "Hoima",
      "Ibanda",
      "Iganga",
      "Isingiro",
      "Jinja",
      "Kaabong",
      "Kabale",
      "Kabarole",
      "Kaberamaido",
      "Kagadi",
      "Kakumiro",
      "Kalaki",
      "Kalangala",
      "Kaliro",
      "Kalungu",
      "Kampala",
      "Kamuli",
      "Kamwenge",
      "Kanungu",
      "Kapchorwa",
      "Kapelebyong",
      "Karenga",
      "Kasanda",
      "Kasese",
      "Katakwi",
      "Kayunga",
      "Kazo",
      "Kibaale",
      "Kiboga",
      "Kibuku",
      "Kikuube",
      "Kiruhura",
      "Kiryandongo",
      "Kisoro",
      "Kitagwenda",
      "Kitgum",
      "Koboko",
      "Kole",
      "Kotido",
      "Kumi",
      "Kwania",
      "Kween",
      "Kyankwanzi",
      "Kyegegwa",
      "Kyenjojo",
      "Kyotera",
      "Lamwo",
      "Lira",
      "Luuka",
      "Luwero",
      "Lwengo",
      "Lyantonde",
      "Madi-Okollo",
      "Manafwa",
      "Maracha",
      "Masaka",
      "Masindi",
      "Mayuge",
      "Mbale",
      "Mbarara",
      "Mitooma",
      "Mityana",
      "Moroto",
      "Moyo",
      "Mpigi",
      "Mubende",
      "Mukono",
      "Nabilatuk",
      "Nakapiripirit",
      "Nakaseke",
      "Nakasongola",
      "Namayingo",
      "Namisindwa",
      "Namutumba",
      "Napak",
      "Nebbi",
      "Ngora",
      "Northern",
      "Ntoroko",
      "Ntungamo",
      "Nwoya",
      "Obongi",
      "Omoro",
      "Otuke",
      "Oyam",
      "Pader",
      "Pakwach",
      "Pallisa",
      "Rakai",
      "Rubanda",
      "Rubirizi",
      "Rukiga",
      "Rukungiri",
      "Rwampara",
      "Sembabule",
      "Serere",
      "Sheema",
      "Sironko",
      "Soroti",
      "Tororo",
      "Wakiso",
      "Western",
      "Yumbe",
      "Zombo"
    ]
  },
  {
    "name": "Ukraine",
    "code": "UA",
    "dial_code": "+380",
    "flag": "🇺🇦",
    "states": [
      "Autonomous Republic of Crimea",
      "Cherkaska",
      "Chernihivska",
      "Chernivetska",
      "Dnipropetrovska",
      "Donetska",
      "Ivano-Frankivska",
      "Kharkivska",
      "Khersonska",
      "Khmelnytska",
      "Kirovohradska",
      "Kyiv",
      "Kyivska",
      "Luhanska",
      "Lvivska",
      "Mykolaivska",
      "Odeska",
      "Poltavska",
      "Rivnenska",
      "Sevastopol",
      "Sumska",
      "Ternopilska",
      "Vinnytska",
      "Volynska",
      "Zakarpatska",
      "Zaporizka",
      "Zhytomyrska"
    ]
  },
  {
    "name": "United Arab Emirates",
    "code": "AE",
    "dial_code": "+971",
    "flag": "🇦🇪",
    "states": [
      "Abu Dhabi",
      "Ajman",
      "Dubai",
      "Fujairah",
      "Ras Al Khaimah",
      "Sharjah",
      "Umm Al Quwain"
    ]
  },
  {
    "name": "United Kingdom",
    "code": "GB",
    "dial_code": "+44",
    "flag": "🇬🇧",
    "states": [
      "Aberdeen",
      "Aberdeenshire",
      "Angus",
      "Antrim",
      "Antrim and Newtownabbey",
      "Ards",
      "Ards and North Down",
      "Argyll and Bute",
      "Armagh",
      "Armagh, Banbridge and Craigavon",
      "Ascension Island",
      "Ballymena",
      "Ballymoney",
      "Banbridge",
      "Barking and Dagenham",
      "Barnet",
      "Barnsley",
      "Bath and North East Somerset",
      "Bedford",
      "Belfast",
      "Bexley",
      "Birmingham",
      "Blackburn with Darwen",
      "Blackpool",
      "Blaenau Gwent",
      "Bolton",
      "Bournemouth",
      "Bracknell Forest",
      "Bradford",
      "Brent",
      "Bridgend",
      "Brighton and Hove",
      "Bristol",
      "Bromley",
      "Buckinghamshire",
      "Bury",
      "Caerphilly",
      "Calderdale",
      "Cambridgeshire",
      "Camden",
      "Cardiff",
      "Carmarthenshire",
      "Carrickfergus",
      "Castlereagh",
      "Causeway Coast and Glens",
      "Central Bedfordshire",
      "Ceredigion",
      "Cheshire East",
      "Cheshire West and Chester",
      "City of Kingston upon Hull",
      "City of Southampton",
      "Clackmannanshire",
      "Coleraine",
      "Conwy",
      "Cookstown",
      "Cornwall",
      "Coventry",
      "Craigavon",
      "Croydon",
      "Cumbria",
      "Darlington",
      "Denbighshire",
      "Derby",
      "Derbyshire",
      "Derry",
      "Derry City and Strabane",
      "Devon",
      "Doncaster",
      "Dorset",
      "Down District Council",
      "Dudley",
      "Dumfries and Galloway",
      "Dundee",
      "Dungannon and South Tyrone",
      "Durham",
      "Ealing",
      "East Ayrshire",
      "East Dunbartonshire",
      "East Lothian",
      "East Renfrewshire",
      "East Riding of Yorkshire",
      "East Sussex",
      "Edinburgh",
      "Enfield",
      "England",
      "Essex",
      "Falkirk",
      "Fermanagh",
      "Fermanagh and Omagh",
      "Fife",
      "Flintshire",
      "Gateshead",
      "Glasgow",
      "Gloucestershire",
      "Greenwich",
      "Gwynedd",
      "Hackney",
      "Halton",
      "Hammersmith and Fulham",
      "Hampshire",
      "Haringey",
      "Harrow",
      "Hartlepool",
      "Havering",
      "Herefordshire",
      "Hertfordshire",
      "Highland",
      "Hillingdon",
      "Hounslow",
      "Inverclyde",
      "Isle of Wight",
      "Isles of Scilly",
      "Islington",
      "Kensington and Chelsea",
      "Kent",
      "Kingston upon Thames",
      "Kirklees",
      "Knowsley",
      "Lambeth",
      "Lancashire",
      "Larne",
      "Leeds",
      "Leicester",
      "Leicestershire",
      "Lewisham",
      "Limavady",
      "Lincolnshire",
      "Lisburn",
      "Lisburn and Castlereagh",
      "Liverpool",
      "London",
      "Magherafelt",
      "Manchester",
      "Medway",
      "Merthyr Tydfil",
      "Merton",
      "Mid and East Antrim",
      "Mid Ulster",
      "Middlesbrough",
      "Midlothian",
      "Milton Keynes",
      "Monmouthshire",
      "Moray",
      "Moyle",
      "Neath Port Talbot",
      "Newcastle upon Tyne",
      "Newham",
      "Newport",
      "Newry and Mourne",
      "Newry, Mourne and Down",
      "Newtownabbey",
      "Norfolk",
      "North Ayrshire",
      "North Down",
      "North East Lincolnshire",
      "North Lanarkshire",
      "North Lincolnshire",
      "North Somerset",
      "North Tyneside",
      "North Yorkshire",
      "Northamptonshire",
      "Northern Ireland",
      "Northumberland",
      "Nottingham",
      "Nottinghamshire",
      "Oldham",
      "Omagh",
      "Orkney Islands",
      "Outer Hebrides",
      "Oxfordshire",
      "Pembrokeshire",
      "Perth and Kinross",
      "Peterborough",
      "Plymouth",
      "Poole",
      "Portsmouth",
      "Powys",
      "Reading",
      "Redbridge",
      "Redcar and Cleveland",
      "Renfrewshire",
      "Rhondda Cynon Taf",
      "Richmond upon Thames",
      "Rochdale",
      "Rotherham",
      "Rutland",
      "Saint Helena",
      "Salford",
      "Sandwell",
      "Scotland",
      "Scottish Borders",
      "Sefton",
      "Sheffield",
      "Shetland Islands",
      "Shropshire",
      "Slough",
      "Solihull",
      "Somerset",
      "South Ayrshire",
      "South Gloucestershire",
      "South Lanarkshire",
      "South Tyneside",
      "Southend-on-Sea",
      "Southwark",
      "St Helens",
      "Staffordshire",
      "Stirling",
      "Stockport",
      "Stockton-on-Tees",
      "Stoke-on-Trent",
      "Strabane",
      "Suffolk",
      "Sunderland",
      "Surrey",
      "Sutton",
      "Swansea",
      "Swindon",
      "Tameside",
      "Telford and Wrekin",
      "Thurrock",
      "Torbay",
      "Torfaen",
      "Tower Hamlets",
      "Trafford",
      "United Kingdom",
      "Vale of Glamorgan",
      "Wakefield",
      "Wales",
      "Walsall",
      "Waltham Forest",
      "Wandsworth",
      "Warrington",
      "Warwickshire",
      "West Berkshire",
      "West Dunbartonshire",
      "West Lothian",
      "West Sussex",
      "Westminster",
      "Wigan",
      "Wiltshire",
      "Windsor and Maidenhead",
      "Wirral",
      "Wokingham",
      "Wolverhampton",
      "Worcestershire",
      "Wrexham",
      "York"
    ]
  },
  {
    "name": "United States",
    "code": "US",
    "dial_code": "+1",
    "flag": "🇺🇸",
    "states": [
      "Alabama",
      "Alaska",
      "American Samoa",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "District of Columbia",
      "Florida",
      "Georgia",
      "Guam",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Northern Mariana Islands",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Puerto Rico",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "United States Minor Outlying Islands",
      "United States Virgin Islands",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming"
    ]
  },
  {
    "name": "Uruguay",
    "code": "UY",
    "dial_code": "+598",
    "flag": "🇺🇾",
    "states": [
      "Artigas",
      "Canelones",
      "Cerro Largo",
      "Colonia",
      "Durazno",
      "Flores",
      "Florida",
      "Lavalleja",
      "Maldonado",
      "Montevideo",
      "Paysandú",
      "Río Negro",
      "Rivera",
      "Rocha",
      "Salto",
      "San José",
      "Soriano",
      "Tacuarembó",
      "Treinta y Tres"
    ]
  },
  {
    "name": "Uzbekistan",
    "code": "UZ",
    "dial_code": "+998",
    "flag": "🇺🇿",
    "states": [
      "Andijan",
      "Bukhara",
      "Fergana",
      "Jizzakh",
      "Karakalpakstan",
      "Namangan",
      "Navoiy",
      "Qashqadaryo",
      "Samarqand",
      "Sirdaryo",
      "Surxondaryo",
      "Tashkent",
      "Tashkent",
      "Xorazm"
    ]
  },
  {
    "name": "Vanuatu",
    "code": "VU",
    "dial_code": "+678",
    "flag": "🇻🇺",
    "states": [
      "Malampa",
      "Penama",
      "Sanma",
      "Shefa",
      "Tafea",
      "Torba"
    ]
  },
  {
    "name": "Vatican City State (Holy See)",
    "code": "VA",
    "dial_code": "+379",
    "flag": "🇻🇦",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Venezuela",
    "code": "VE",
    "dial_code": "+58",
    "flag": "🇻🇪",
    "states": [
      "Amazonas",
      "Anzoátegui",
      "Apure",
      "Aragua",
      "Barinas",
      "Bolívar",
      "Carabobo",
      "Cojedes",
      "Delta Amacuro",
      "Distrito Capital",
      "Falcón",
      "Guárico",
      "La Guaira",
      "Lara",
      "Mérida",
      "Miranda",
      "Monagas",
      "Nueva Esparta",
      "Portuguesa",
      "Sucre",
      "Táchira",
      "Trujillo",
      "Venezuela",
      "Yaracuy",
      "Zulia"
    ]
  },
  {
    "name": "Vietnam",
    "code": "VN",
    "dial_code": "+84",
    "flag": "🇻🇳",
    "states": [
      "An Giang",
      "Bà Rịa-Vũng Tàu",
      "Bắc Giang",
      "Bắc Kạn",
      "Bạc Liêu",
      "Bắc Ninh",
      "Bến Tre",
      "Bình Dương",
      "Bình Định",
      "Bình Phước",
      "Bình Thuận",
      "Cà Mau",
      "Cần Thơ",
      "Cao Bằng",
      "Đà Nẵng",
      "Đắk Lắk",
      "Đắk Nông",
      "Điện Biên",
      "Đồng Nai",
      "Đồng Tháp",
      "Gia Lai",
      "Hà Giang",
      "Hà Nam",
      "Hà Nội",
      "Hà Tĩnh",
      "Hải Dương",
      "Hải Phòng",
      "Hậu Giang",
      "Hồ Chí Minh",
      "Hòa Bình",
      "Hưng Yên",
      "Khánh Hòa",
      "Kiên Giang",
      "Kon Tum",
      "Lai Châu",
      "Lâm Đồng",
      "Lạng Sơn",
      "Lào Cai",
      "Long An",
      "Nam Định",
      "Nghệ An",
      "Ninh Bình",
      "Ninh Thuận",
      "Phú Thọ",
      "Phú Yên",
      "Quảng Bình",
      "Quảng Nam",
      "Quảng Ngãi",
      "Quảng Ninh",
      "Quảng Trị",
      "Sóc Trăng",
      "Sơn La",
      "Tây Ninh",
      "Thái Bình",
      "Thái Nguyên",
      "Thanh Hóa",
      "Thừa Thiên-Huế",
      "Tiền Giang",
      "Trà Vinh",
      "Tuyên Quang",
      "Vĩnh Long",
      "Vĩnh Phúc",
      "Yên Bái"
    ]
  },
  {
    "name": "Virgin Islands (British)",
    "code": "VG",
    "dial_code": "+1",
    "flag": "🇻🇬",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Virgin Islands (US)",
    "code": "VI",
    "dial_code": "+1",
    "flag": "🇻🇮",
    "states": [
      "Saint Croix",
      "Saint John",
      "Saint Thomas"
    ]
  },
  {
    "name": "Wallis and Futuna Islands",
    "code": "WF",
    "dial_code": "+681",
    "flag": "🇼🇫",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Western Sahara",
    "code": "EH",
    "dial_code": "+212",
    "flag": "🇪🇭",
    "states": [
      "No states"
    ]
  },
  {
    "name": "Yemen",
    "code": "YE",
    "dial_code": "+967",
    "flag": "🇾🇪",
    "states": [
      "'Adan",
      "'Amran",
      "Abyan",
      "Al Bayda'",
      "Al Hudaydah",
      "Al Jawf",
      "Al Mahrah",
      "Al Mahwit",
      "Amanat Al Asimah",
      "Dhamar",
      "Hadhramaut",
      "Hajjah",
      "Ibb",
      "Lahij",
      "Ma'rib",
      "Raymah",
      "Saada",
      "Sana'a",
      "Shabwah",
      "Socotra",
      "Ta'izz"
    ]
  },
  {
    "name": "Zambia",
    "code": "ZM",
    "dial_code": "+260",
    "flag": "🇿🇲",
    "states": [
      "Central",
      "Copperbelt",
      "Eastern",
      "Luapula",
      "Lusaka",
      "Muchinga",
      "Northern",
      "Northwestern",
      "Southern",
      "Western"
    ]
  },
  {
    "name": "Zimbabwe",
    "code": "ZW",
    "dial_code": "+263",
    "flag": "🇿🇼",
    "states": [
      "Bulawayo",
      "Harare",
      "Manicaland",
      "Mashonaland Central",
      "Mashonaland East",
      "Mashonaland West",
      "Masvingo",
      "Matabeleland North",
      "Matabeleland South",
      "Midlands"
    ]
  }
]
